{
  "level": "q303",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q303",
    "objects": "AREAS.E3:q303.e3",
    "mesh": "TREES.E3:q303.e3"
  },
  "spawn_point": {
    "position": [
      707.2239766112411,
      733.890372318805,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      707.2239766112411,
      833.890372318805,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3000.0,
      -4764.30029296875,
      -300.0
    ],
    "bbox_max": [
      6992.10546875,
      7450.0,
      1857.3123779296875
    ],
    "vertex_count": 1122,
    "vertices": [
      [
        -3000.0,
        -3210.00390625,
        1194.0616455078125
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -3527.920166015625,
        960.6837768554688
      ],
      [
        -3000.0,
        -4714.78125,
        1390.1104736328125
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3000.0,
        -3565.30615234375,
        1052.5999755859375
      ],
      [
        -2881.897705078125,
        -4764.30029296875,
        1390.1087646484375
      ],
      [
        -2880.93603515625,
        -4709.201171875,
        1219.6473388671875
      ],
      [
        -2852.99609375,
        -3108.556396484375,
        0.0
      ],
      [
        -2853.1044921875,
        -3114.76806640625,
        11.255549430847168
      ],
      [
        -2853.1044921875,
        -3114.76806640625,
        11.2554931640625
      ],
      [
        -2860.521728515625,
        -3539.687744140625,
        1052.5999755859375
      ],
      [
        -800.0,
        -1452.5167236328125,
        0.0
      ],
      [
        -800.0,
        -1855.504150390625,
        287.160888671875
      ],
      [
        -800.0,
        -2100.0,
        508.155517578125
      ],
      [
        -800.0,
        -1855.504150390625,
        287.1609191894531
      ],
      [
        -2708.39404296875,
        6871.484375,
        100.0
      ],
      [
        -800.0,
        7251.08740234375,
        100.0
      ],
      [
        -800.0,
        7251.08740234375,
        -22.699951171875
      ],
      [
        -2708.39404296875,
        6871.484375,
        140.0
      ],
      [
        -800.0,
        7251.08740234375,
        140.0
      ],
      [
        -800.0,
        7251.08740234375,
        976.300048828125
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        -800.0,
        7251.08740234375,
        608.452392578125
      ],
      [
        3108.39404296875,
        6871.484375,
        623.0784912109375
      ],
      [
        816.3760375976562,
        7327.39501953125,
        652.46484375
      ],
      [
        2400.0,
        -2849.047607421875,
        1857.3123779296875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        2400.0,
        -1319.93994140625,
        329.84539794921875
      ],
      [
        2400.0,
        -1246.433349609375,
        296.433349609375
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -867.0938720703125,
        16.99639320373535
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -743.0372314453125,
        -300.0
      ],
      [
        1290.0,
        720.0,
        100.0
      ],
      [
        1290.0,
        720.0,
        60.0
      ],
      [
        1290.0,
        720.0,
        100.0
      ],
      [
        1290.0,
        720.0,
        350.0
      ],
      [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      [
        1910.0,
        1624.0,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1541.0,
        1270.0,
        490.0
      ],
      [
        1541.0,
        1270.0,
        630.1036376953125
      ],
      [
        1528.181884765625,
        1398.181884765625,
        711.67822265625
      ],
      [
        1541.0,
        1270.0,
        630.1036376953125
      ],
      [
        1455.4544677734375,
        1325.4544677734375,
        608.8261108398438
      ],
      [
        1460.9998779296875,
        1270.0,
        573.5350341796875
      ],
      [
        1460.9998779296875,
        1270.0,
        490.0
      ],
      [
        1460.9998779296875,
        1270.0,
        573.5350341796875
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1290.0,
        1050.0,
        330.10211181640625
      ],
      [
        1290.0,
        1050.0,
        160.0
      ],
      [
        1600.0,
        720.0,
        100.0
      ],
      [
        1600.0,
        720.0,
        240.0
      ],
      [
        1290.0,
        700.0,
        258.0
      ],
      [
        720.0,
        1570.0,
        190.0
      ],
      [
        720.0,
        1570.0,
        80.0
      ],
      [
        720.0,
        1690.0,
        195.16659545898438
      ],
      [
        720.0,
        1690.0,
        145.16661071777344
      ],
      [
        720.0,
        1690.0,
        140.0
      ],
      [
        720.0,
        1690.0,
        145.16661071777344
      ],
      [
        720.0,
        1690.0,
        60.0
      ],
      [
        720.0,
        1690.0,
        120.0
      ],
      [
        720.0,
        1690.0,
        140.0
      ],
      [
        720.0,
        1690.0,
        120.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        1083.078369140625,
        1690.0,
        329.0
      ],
      [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      [
        780.0,
        1580.0,
        100.0
      ],
      [
        780.0,
        1580.0,
        60.0
      ],
      [
        806.0,
        1580.0,
        100.0
      ],
      [
        806.0,
        1580.0,
        120.0
      ],
      [
        806.0,
        1580.0,
        120.0
      ],
      [
        806.0,
        1580.0,
        216.0
      ],
      [
        790.0,
        1664.0,
        100.0
      ],
      [
        790.0,
        1664.0,
        120.0
      ],
      [
        790.0,
        1664.0,
        120.0
      ],
      [
        790.0,
        1664.0,
        216.0
      ],
      [
        790.0,
        1663.9998779296875,
        100.0
      ],
      [
        790.0,
        1670.0,
        100.0
      ],
      [
        794.2857666015625,
        1661.428466796875,
        100.0
      ],
      [
        790.0,
        1580.0,
        100.0
      ],
      [
        780.0,
        1580.0,
        100.0
      ],
      [
        790.0,
        1580.0,
        100.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        120.0
      ],
      [
        790.0,
        1580.0,
        216.0
      ],
      [
        730.0,
        1580.0,
        60.0
      ],
      [
        720.0,
        1580.0,
        80.0
      ],
      [
        721.0,
        1690.0,
        78.0
      ],
      [
        720.0,
        1580.0,
        78.0
      ],
      [
        721.0,
        1580.0,
        78.0
      ],
      [
        740.0,
        1580.0,
        80.0
      ],
      [
        720.0,
        1580.0,
        80.0
      ],
      [
        740.0,
        1580.0,
        78.0
      ],
      [
        740.0,
        1580.0,
        80.0
      ],
      [
        740.0,
        1580.0,
        78.0
      ],
      [
        760.0,
        1580.0,
        98.0
      ],
      [
        780.0,
        1580.0,
        98.0
      ],
      [
        760.0,
        1580.0,
        100.0
      ],
      [
        780.0,
        1580.0,
        100.0
      ],
      [
        760.0,
        1580.0,
        98.0
      ],
      [
        760.0,
        1580.0,
        100.0
      ],
      [
        730.0,
        1570.0,
        60.0
      ],
      [
        720.0,
        1570.0,
        80.0
      ],
      [
        720.0,
        1570.0,
        78.0
      ],
      [
        721.0,
        1570.0,
        78.0
      ],
      [
        721.0,
        1580.0,
        78.0
      ],
      [
        720.0,
        1570.0,
        80.0
      ],
      [
        720.0,
        1450.0,
        60.0
      ],
      [
        820.0,
        1450.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        78.0
      ],
      [
        790.0,
        1530.0,
        80.0
      ],
      [
        790.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        78.0
      ],
      [
        780.0,
        1530.0,
        80.0
      ],
      [
        820.0,
        1450.0,
        180.0
      ],
      [
        780.0,
        1450.0,
        140.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        720.0,
        1450.0,
        78.0
      ],
      [
        721.0,
        1450.0,
        78.0
      ],
      [
        721.0,
        1560.0,
        78.0
      ],
      [
        721.0,
        1570.0,
        78.0
      ],
      [
        720.0,
        1459.0,
        78.0
      ],
      [
        721.0,
        1459.0,
        78.0
      ],
      [
        740.0,
        1450.0,
        80.0
      ],
      [
        720.0,
        1450.0,
        80.0
      ],
      [
        740.0,
        1450.0,
        78.0
      ],
      [
        740.0,
        1450.0,
        78.0
      ],
      [
        740.0,
        1450.0,
        80.0
      ],
      [
        780.0,
        1420.0,
        60.0
      ],
      [
        980.0,
        1420.0,
        80.0
      ],
      [
        780.0,
        1420.0,
        78.0
      ],
      [
        820.0,
        1420.0,
        78.0
      ],
      [
        780.0,
        1420.0,
        78.0
      ],
      [
        780.0,
        1420.0,
        80.0
      ],
      [
        905.0,
        1170.0,
        72.5
      ],
      [
        905.0,
        1170.0,
        80.0
      ],
      [
        905.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1320.0,
        78.0
      ],
      [
        780.0,
        1320.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1170.0,
        80.0
      ],
      [
        780.0,
        1170.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        78.0
      ],
      [
        780.0,
        1280.0,
        80.0
      ],
      [
        780.0,
        1310.0,
        78.0
      ],
      [
        780.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        80.0
      ],
      [
        790.0,
        1310.0,
        78.0
      ],
      [
        717.8607788085938,
        1280.0,
        140.0
      ],
      [
        717.8607788085938,
        1280.0,
        160.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        717.8607788085938,
        1280.0,
        550.0
      ],
      [
        717.8607788085938,
        1280.0,
        160.0
      ],
      [
        717.8607788085938,
        1280.0,
        520.0
      ],
      [
        512.1392211914062,
        1280.0,
        520.0
      ],
      [
        512.1392211914062,
        1280.0,
        550.0
      ],
      [
        512.1392211914062,
        1280.0,
        160.0
      ],
      [
        512.1392211914062,
        1280.0,
        520.0
      ],
      [
        612.5,
        1280.0,
        518.0
      ],
      [
        617.5,
        1280.0,
        518.0
      ],
      [
        612.5,
        1300.3714599609375,
        520.0
      ],
      [
        612.5,
        1300.3714599609375,
        518.0
      ],
      [
        612.5,
        1280.0,
        520.0
      ],
      [
        612.5,
        1280.0,
        518.0
      ],
      [
        820.0,
        1310.0,
        140.0
      ],
      [
        627.7926025390625,
        1225.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        500.0
      ],
      [
        627.7926025390625,
        1222.0,
        501.5
      ],
      [
        602.2073974609375,
        1225.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        500.0
      ],
      [
        602.2073974609375,
        1222.0,
        501.5
      ],
      [
        490.0,
        1130.0,
        190.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        440.0,
        1130.0,
        340.0
      ],
      [
        910.0,
        1232.41455078125,
        140.0
      ],
      [
        910.0,
        1232.41455078125,
        280.0
      ],
      [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        780.0,
        1320.0,
        100.0
      ],
      [
        780.0,
        1310.0,
        100.0
      ],
      [
        780.0,
        1180.0,
        80.0
      ],
      [
        980.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        118.0
      ],
      [
        980.0,
        1130.0,
        118.0
      ],
      [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      [
        1250.0,
        1050.0,
        160.0
      ],
      [
        650.0,
        505.8578186035156,
        80.0
      ],
      [
        650.0,
        505.85784912109375,
        78.0
      ],
      [
        630.0,
        485.8577880859375,
        60.0
      ],
      [
        620.0,
        475.8577880859375,
        80.0
      ],
      [
        650.0,
        324.60308837890625,
        80.0
      ],
      [
        630.0,
        485.8578186035156,
        80.0
      ],
      [
        650.0,
        505.85784912109375,
        80.0
      ],
      [
        650.0,
        324.60308837890625,
        78.0
      ],
      [
        630.0,
        485.8578186035156,
        78.0
      ],
      [
        650.0,
        505.8578186035156,
        78.0
      ],
      [
        630.0,
        485.8578186035156,
        80.0
      ],
      [
        630.0,
        485.8578186035156,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        80.0
      ],
      [
        630.0,
        281.61761474609375,
        78.0
      ],
      [
        650.0,
        283.51434326171875,
        78.0
      ],
      [
        650.0,
        283.51434326171875,
        80.0
      ],
      [
        621.0,
        289.8044738769531,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        80.0
      ],
      [
        650.0,
        283.51434326171875,
        60.0
      ],
      [
        650.0,
        283.51434326171875,
        150.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        624.1422119140625,
        480.0,
        98.0
      ],
      [
        620.0,
        475.8577880859375,
        98.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        460.0,
        100.0
      ],
      [
        620.0,
        475.8577880859375,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        100.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        460.0,
        100.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        98.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        760.0,
        320.0,
        78.0
      ],
      [
        760.0,
        320.0,
        80.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        100.0
      ],
      [
        804.5620727539062,
        660.419921875,
        100.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        100.0
      ],
      [
        804.5620727539062,
        660.419921875,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        100.0
      ],
      [
        1024.1422119140625,
        880.0,
        80.0
      ],
      [
        1074.1422119140625,
        930.0,
        80.0
      ],
      [
        1210.0,
        707.730224609375,
        78.0
      ],
      [
        1210.0,
        707.730224609375,
        80.0
      ],
      [
        1230.0,
        707.730224609375,
        78.0
      ],
      [
        1210.0,
        707.730224609375,
        78.0
      ],
      [
        794.1422119140625,
        650.0,
        60.0
      ],
      [
        650.0,
        505.8578186035156,
        60.0
      ],
      [
        658.9999389648438,
        324.60308837890625,
        78.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        658.9999389648438,
        344.5075988769531,
        78.0
      ],
      [
        844.1421508789062,
        700.0,
        60.0
      ],
      [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        1190.468017578125,
        707.368408203125,
        80.0
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      [
        851.8724365234375,
        707.730224609375,
        78.31001281738281
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        867.0823364257812,
        722.9401245117188,
        80.0
      ],
      [
        1190.0,
        707.730224609375,
        100.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        804.1421508789062,
        660.0,
        98.0
      ],
      [
        824.1422119140625,
        680.0,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        1004.0,
        640.0,
        100.0
      ],
      [
        1004.0,
        650.0,
        100.0
      ],
      [
        1004.0,
        650.0,
        100.0
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        100.0
      ],
      [
        1200.0,
        930.0,
        100.0
      ],
      [
        1076.3074951171875,
        930.0,
        80.0
      ],
      [
        1076.3074951171875,
        930.0,
        100.0
      ],
      [
        1013.6077270507812,
        869.4655151367188,
        96.28055572509766
      ],
      [
        1074.1422119140625,
        930.0,
        80.0
      ],
      [
        1074.1422119140625,
        930.0,
        100.0
      ],
      [
        660.0,
        515.8578491210938,
        190.0
      ],
      [
        660.1421508789062,
        516.0,
        190.0
      ],
      [
        930.0,
        640.0,
        120.0
      ],
      [
        930.0,
        366.79339599609375,
        120.0
      ],
      [
        930.0,
        387.9854736328125,
        120.0
      ],
      [
        660.1421508789062,
        516.0,
        140.0
      ],
      [
        660.0,
        515.8578491210938,
        140.0
      ],
      [
        660.1421508789062,
        516.0,
        190.0
      ],
      [
        660.1421508789062,
        516.0,
        140.0
      ],
      [
        660.0,
        515.8578491210938,
        140.0
      ],
      [
        660.0,
        515.8578491210938,
        150.0
      ],
      [
        660.0,
        515.8578491210938,
        190.0
      ],
      [
        660.0,
        515.8578491210938,
        150.0
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        324.5968933105469,
        140.0
      ],
      [
        660.0,
        344.507568359375,
        140.0
      ],
      [
        660.0,
        460.0,
        140.0
      ],
      [
        868.9588623046875,
        344.4016418457031,
        190.0
      ],
      [
        868.9588623046875,
        344.4016418457031,
        155.0
      ],
      [
        840.0,
        341.656982421875,
        155.0
      ],
      [
        868.9588623046875,
        344.4016418457031,
        140.0
      ],
      [
        840.0,
        341.656982421875,
        140.0
      ],
      [
        688.2210083007812,
        515.5,
        140.0
      ],
      [
        688.2210083007812,
        515.5,
        155.0
      ],
      [
        688.199951171875,
        515.5478515625,
        145.0
      ],
      [
        688.0001831054688,
        516.0,
        145.0
      ],
      [
        673.1790161132812,
        515.5,
        155.0
      ],
      [
        673.1790161132812,
        515.5,
        140.0
      ],
      [
        673.199951171875,
        515.5475463867188,
        145.0
      ],
      [
        673.3998413085938,
        516.0,
        145.0
      ],
      [
        662.3732299804688,
        505.199951171875,
        142.39999389648438
      ],
      [
        662.373291015625,
        505.800048828125,
        142.39999389648438
      ],
      [
        662.373291015625,
        505.800048828125,
        142.39999389648438
      ],
      [
        662.3999633789062,
        506.0,
        142.0
      ],
      [
        662.3732299804688,
        505.199951171875,
        142.39999389648438
      ],
      [
        703.0750122070312,
        497.8999938964844,
        144.0
      ],
      [
        703.112548828125,
        497.8499755859375,
        144.5
      ],
      [
        703.112548828125,
        495.1500244140625,
        144.5
      ],
      [
        703.0750122070312,
        495.1000061035156,
        144.0
      ],
      [
        703.5,
        497.8999938964844,
        144.0
      ],
      [
        703.5,
        497.8499755859375,
        144.5
      ],
      [
        703.112548828125,
        497.8499755859375,
        144.5
      ],
      [
        703.0750122070312,
        497.8999938964844,
        144.0
      ],
      [
        703.0750122070312,
        495.1000061035156,
        144.0
      ],
      [
        703.112548828125,
        495.1500244140625,
        144.5
      ],
      [
        703.5,
        495.1500244140625,
        144.5
      ],
      [
        703.5,
        495.1000061035156,
        144.0
      ],
      [
        700.75,
        498.0,
        143.0
      ],
      [
        703.5,
        495.875,
        143.0
      ],
      [
        702.2777709960938,
        496.1111145019531,
        141.11111450195312
      ],
      [
        700.0,
        495.875,
        143.0
      ],
      [
        651.0,
        491.0,
        140.0
      ],
      [
        651.0,
        491.0,
        143.5
      ],
      [
        651.0,
        471.0,
        140.0
      ],
      [
        650.0,
        471.0,
        140.0
      ],
      [
        651.0,
        471.0,
        143.5
      ],
      [
        660.0,
        471.0,
        140.0
      ],
      [
        930.0,
        600.0,
        140.0
      ],
      [
        930.0,
        600.0,
        190.0
      ],
      [
        880.0,
        640.0,
        190.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        880.0,
        640.0,
        190.0
      ],
      [
        840.0,
        640.0,
        190.0
      ],
      [
        840.0,
        640.0,
        140.0
      ],
      [
        840.0,
        640.0,
        120.0
      ],
      [
        840.0,
        460.0,
        120.0
      ],
      [
        930.0,
        640.0,
        120.0
      ],
      [
        930.0,
        640.0,
        100.0
      ],
      [
        930.0,
        366.79339599609375,
        220.0
      ],
      [
        930.0,
        387.9854736328125,
        220.0
      ],
      [
        1235.0,
        707.730224609375,
        120.0
      ],
      [
        1060.0,
        707.730224609375,
        120.0
      ],
      [
        1060.0,
        414.4813232421875,
        120.0
      ],
      [
        1060.0,
        435.79931640625,
        120.0
      ],
      [
        1060.0,
        414.4813232421875,
        220.0
      ],
      [
        1060.0,
        435.79931640625,
        220.0
      ],
      [
        1100.0,
        640.0,
        220.0
      ],
      [
        1060.0,
        640.0,
        220.0
      ],
      [
        1060.0,
        640.0,
        120.0
      ],
      [
        1060.0,
        640.0,
        100.0
      ],
      [
        1235.0,
        707.730224609375,
        118.0
      ],
      [
        1235.0,
        707.730224609375,
        118.0
      ],
      [
        1060.0,
        707.730224609375,
        118.0
      ],
      [
        990.0,
        640.0,
        220.0
      ],
      [
        950.0,
        640.0,
        220.0
      ],
      [
        990.0,
        640.0,
        220.0
      ],
      [
        950.0,
        640.0,
        220.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1036.0,
        640.0,
        118.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1094.14208984375,
        950.0,
        380.0
      ],
      [
        1084.1422119140625,
        940.0,
        130.0
      ],
      [
        1240.0,
        945.107666015625,
        257.6921081542969
      ],
      [
        1240.0,
        941.2000122070312,
        160.0
      ],
      [
        1240.0,
        940.108154296875,
        256.35247802734375
      ],
      [
        1240.0,
        932.4000244140625,
        160.0
      ],
      [
        1170.000244140625,
        930.0,
        130.0
      ],
      [
        1168.800048828125,
        930.0,
        100.0
      ],
      [
        1074.1422119140625,
        930.0,
        130.0
      ],
      [
        1084.1422119140625,
        940.0,
        145.0
      ],
      [
        1074.1422119140625,
        930.0,
        130.0
      ],
      [
        1094.1422119140625,
        950.0,
        380.0
      ],
      [
        1101.1422119140625,
        957.0,
        580.0
      ],
      [
        1101.1422119140625,
        957.0,
        580.0
      ],
      [
        1101.1422119140625,
        957.0,
        750.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        120.0
      ],
      [
        1013.0952758789062,
        868.953125,
        120.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        120.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        120.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        120.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        120.0
      ],
      [
        1013.0952758789062,
        868.953125,
        120.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1034.159912109375,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        120.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        118.0
      ],
      [
        1013.0952758789062,
        868.953125,
        118.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        118.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        118.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        118.0
      ],
      [
        1013.0952758789062,
        868.953125,
        118.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        118.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        120.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        118.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1150.0,
        747.730224609375,
        170.0
      ],
      [
        1100.0,
        785.0,
        170.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1100.0,
        825.0,
        170.0
      ],
      [
        1100.0,
        825.0,
        145.0
      ],
      [
        1100.0,
        785.0,
        170.0
      ],
      [
        1150.0,
        785.0,
        170.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1060.0,
        780.0,
        195.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1100.0,
        785.0,
        195.0
      ],
      [
        1100.0,
        825.0,
        195.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1100.0,
        785.0,
        195.0
      ],
      [
        1088.730224609375,
        709.0,
        190.0
      ],
      [
        1161.269775390625,
        709.0,
        190.0
      ],
      [
        1088.730224609375,
        709.0,
        190.0
      ],
      [
        1088.730224609375,
        709.0,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        190.0
      ],
      [
        1088.730224609375,
        709.0,
        190.0
      ],
      [
        1088.730224609375,
        709.0,
        195.0
      ],
      [
        1088.730224609375,
        709.0,
        183.5
      ],
      [
        1161.269775390625,
        709.0,
        183.5
      ],
      [
        1088.730224609375,
        709.0,
        183.5
      ],
      [
        1088.730224609375,
        709.0,
        180.0
      ],
      [
        1090.0,
        707.730224609375,
        183.5
      ],
      [
        1088.730224609375,
        709.0,
        180.0
      ],
      [
        1088.730224609375,
        709.0,
        183.5
      ],
      [
        1190.0,
        739.0001220703125,
        190.0
      ],
      [
        1189.0,
        770.0,
        183.5
      ],
      [
        1189.0,
        749.0,
        183.5
      ],
      [
        1189.0,
        749.0,
        180.0
      ],
      [
        1189.0,
        749.0,
        190.0
      ],
      [
        1189.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        749.0,
        195.0
      ],
      [
        1190.0,
        749.0,
        190.0
      ],
      [
        1190.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        749.0,
        190.0
      ],
      [
        1060.0,
        770.0,
        190.0
      ],
      [
        1060.0,
        749.0,
        190.0
      ],
      [
        1061.0,
        749.0,
        190.0
      ],
      [
        1061.0,
        770.0,
        190.0
      ],
      [
        1061.0,
        770.0,
        183.5
      ],
      [
        1061.0,
        749.0,
        183.5
      ],
      [
        1060.0,
        749.0,
        183.5
      ],
      [
        1060.0,
        770.0,
        183.5
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1020.0,
        930.0,
        130.0
      ],
      [
        1018.0,
        930.0,
        80.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1084.542236328125,
        940.4000244140625,
        140.0
      ],
      [
        1020.7999877929688,
        970.4000244140625,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        1050.4000244140625,
        940.7999877929688,
        140.0
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1020.7999877929688,
        1079.5999755859375,
        140.0
      ],
      [
        1080.808837890625,
        936.6666870117188,
        140.0
      ],
      [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      [
        1019.9999389648438,
        930.0,
        130.0
      ],
      [
        1020.3999633789062,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1018.0,
        930.0,
        80.0
      ],
      [
        1044.1422119140625,
        900.0,
        80.0
      ],
      [
        1017.9999389648438,
        900.0,
        80.0
      ],
      [
        1016.6666870117188,
        1083.3333740234375,
        140.0
      ],
      [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      [
        1016.6666870117188,
        966.2667236328125,
        140.0
      ],
      [
        1016.6666870117188,
        930.7999877929688,
        140.0
      ],
      [
        1016.6666870117188,
        1083.7332763671875,
        140.0
      ],
      [
        1010.0,
        900.0,
        80.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        950.0,
        920.0,
        80.0
      ],
      [
        1010.0,
        900.0,
        80.0
      ],
      [
        950.0,
        900.0,
        80.0
      ],
      [
        950.0,
        970.0,
        78.88888549804688
      ],
      [
        950.0,
        930.0,
        78.88888549804688
      ],
      [
        950.0,
        920.0,
        78.88888549804688
      ],
      [
        950.0,
        920.0,
        80.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        950.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        960.0,
        930.0,
        110.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        950.0,
        920.0,
        104.99999237060547
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        1020.4000244140625,
        950.0,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1038.0,
        957.0,
        580.0
      ],
      [
        1055.0,
        950.0,
        255.0000762939453
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1010.7999877929688,
        950.0,
        140.0
      ],
      [
        1010.7999877929688,
        940.4000244140625,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        998.6842041015625,
        940.3999633789062,
        140.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        995.8233032226562,
        944.6067504882812,
        245.16859436035156
      ],
      [
        989.084228515625,
        930.7999877929688,
        140.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        986.7498168945312,
        940.6796264648438,
        263.4952392578125
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        950.0,
        900.0,
        249.50100708007812
      ],
      [
        950.0,
        924.7737426757812,
        337.72265625
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        760.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        80.0
      ],
      [
        780.0,
        900.0,
        60.0
      ],
      [
        780.0,
        900.0,
        80.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        780.0,
        1130.0,
        110.0
      ],
      [
        780.0,
        1130.0,
        108.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        76.66666412353516
      ],
      [
        950.0,
        920.0,
        110.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        110.0
      ],
      [
        930.0,
        900.0,
        80.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        805.0,
        1045.0,
        140.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      [
        805.0,
        1045.0,
        140.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        760.0,
        900.0,
        120.0
      ],
      [
        780.0,
        900.0,
        120.0
      ],
      [
        780.0,
        900.0,
        118.0
      ],
      [
        760.0,
        900.0,
        118.0
      ],
      [
        760.0,
        900.0,
        220.0
      ],
      [
        810.0,
        900.0,
        453.33331298828125
      ],
      [
        892.7614135742188,
        900.0,
        453.3333435058594
      ],
      [
        760.0,
        615.8577880859375,
        98.0
      ],
      [
        760.0,
        644.163818359375,
        98.0
      ],
      [
        760.0,
        644.1637573242188,
        100.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        760.0,
        644.163818359375,
        100.0
      ],
      [
        760.0,
        644.1637573242188,
        98.0
      ],
      [
        760.0,
        630.0,
        60.0
      ],
      [
        760.0,
        615.8578491210938,
        80.0
      ],
      [
        770.0,
        680.0,
        80.0
      ],
      [
        766.0986328125,
        680.0,
        80.0
      ],
      [
        760.0,
        680.0,
        80.0
      ],
      [
        766.0986328125,
        680.0,
        80.0
      ],
      [
        770.0,
        680.0,
        78.0
      ],
      [
        766.0986328125,
        680.0,
        78.0
      ],
      [
        766.0986328125,
        680.0,
        78.0
      ],
      [
        760.0,
        680.0,
        78.0
      ],
      [
        770.0,
        680.0,
        80.0
      ],
      [
        770.0,
        680.0,
        78.0
      ],
      [
        1028.1990966796875,
        900.0,
        80.0
      ],
      [
        780.0,
        900.0,
        118.00000762939453
      ],
      [
        780.0,
        900.0,
        120.0
      ],
      [
        780.0,
        750.0,
        118.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        118.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        118.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        118.0
      ],
      [
        866.452880859375,
        736.452880859375,
        118.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        118.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        118.0
      ],
      [
        866.452880859375,
        736.452880859375,
        118.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        120.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        120.0
      ],
      [
        866.452880859375,
        736.452880859375,
        120.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        120.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        120.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        120.0
      ],
      [
        866.452880859375,
        736.452880859375,
        120.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        120.0
      ],
      [
        852.3160400390625,
        734.2525634765625,
        120.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        120.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        118.0
      ],
      [
        852.3160400390625,
        734.2525634765625,
        118.0
      ],
      [
        850.7107543945312,
        764.1421508789062,
        120.0
      ],
      [
        850.7107543945312,
        764.1421508789062,
        118.0
      ],
      [
        980.0,
        893.431396484375,
        120.0
      ],
      [
        980.0,
        893.431396484375,
        118.0
      ],
      [
        770.0,
        715.0,
        63.31644058227539
      ],
      [
        760.0,
        715.0,
        63.31644058227539
      ],
      [
        770.0,
        682.0499267578125,
        80.0
      ],
      [
        764.0150146484375,
        682.0499267578125,
        80.0
      ],
      [
        760.0,
        682.0499267578125,
        80.0
      ],
      [
        764.0150146484375,
        682.0499267578125,
        80.0
      ],
      [
        620.0,
        980.0,
        160.0
      ],
      [
        620.0,
        980.0,
        190.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        620.0,
        980.0,
        120.0
      ],
      [
        620.0,
        980.0,
        190.0
      ],
      [
        620.0,
        1110.0,
        190.0
      ],
      [
        760.0,
        980.0,
        80.0
      ],
      [
        740.0,
        980.0,
        80.0
      ],
      [
        760.0,
        980.0,
        78.0
      ],
      [
        740.0,
        980.0,
        78.0
      ],
      [
        740.0,
        980.0,
        78.0
      ],
      [
        740.0,
        980.0,
        80.0
      ],
      [
        721.0,
        980.0,
        78.0
      ],
      [
        721.0,
        1111.0,
        78.0
      ],
      [
        730.0,
        980.0,
        60.0
      ],
      [
        620.0,
        996.0,
        120.0
      ],
      [
        620.0,
        1000.0,
        120.0
      ],
      [
        620.0,
        1090.0,
        120.0
      ],
      [
        620.0,
        1110.0,
        120.0
      ],
      [
        620.0,
        980.0,
        120.0
      ],
      [
        620.0,
        1000.0,
        120.0
      ],
      [
        620.0,
        1110.0,
        160.0
      ],
      [
        620.0,
        1090.0,
        160.0
      ],
      [
        620.0,
        1000.0,
        160.0
      ],
      [
        620.0,
        980.0,
        160.0
      ],
      [
        620.0,
        1000.0,
        160.0
      ],
      [
        620.0,
        1000.0,
        120.0
      ],
      [
        620.0,
        940.0,
        78.0
      ],
      [
        620.0,
        940.0,
        80.0
      ],
      [
        620.0,
        970.0,
        60.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        760.0,
        979.0,
        78.0
      ],
      [
        740.0,
        979.0,
        78.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        620.0,
        980.0,
        78.0
      ],
      [
        620.0,
        979.0,
        78.0
      ],
      [
        721.0,
        979.0,
        78.0
      ],
      [
        721.0,
        980.0,
        78.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        740.0,
        979.0,
        78.0
      ],
      [
        760.0,
        940.0,
        80.0
      ],
      [
        620.0,
        940.0,
        80.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        760.0,
        940.0,
        78.0
      ],
      [
        620.0,
        940.0,
        78.0
      ],
      [
        620.0,
        540.0,
        80.0
      ],
      [
        620.0,
        560.0,
        80.0
      ],
      [
        620.0,
        604.1421508789062,
        80.0
      ],
      [
        620.0,
        540.0,
        78.0
      ],
      [
        620.0,
        540.0,
        80.0
      ],
      [
        670.0,
        540.0,
        60.0
      ],
      [
        684.1421508789062,
        540.0,
        80.0
      ],
      [
        744.8577270507812,
        681.0,
        78.0
      ],
      [
        740.0194091796875,
        676.1616821289062,
        78.0
      ],
      [
        740.0194091796875,
        676.1616821289062,
        78.0
      ],
      [
        740.0097045898438,
        676.1519775390625,
        78.0
      ],
      [
        639.9603271484375,
        540.0,
        78.0
      ],
      [
        744.8577270507812,
        681.0,
        78.0
      ],
      [
        760.0,
        696.142333984375,
        78.0
      ],
      [
        620.0,
        556.14208984375,
        78.0
      ],
      [
        620.0,
        540.0,
        78.0
      ],
      [
        740.0097045898438,
        676.1519775390625,
        78.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        639.9603271484375,
        540.0,
        80.0
      ],
      [
        639.9603271484375,
        540.0,
        78.0
      ],
      [
        620.0,
        520.0,
        60.0
      ],
      [
        630.0,
        487.2720031738281,
        78.0
      ],
      [
        650.0,
        507.2720031738281,
        78.0
      ],
      [
        650.0,
        507.27203369140625,
        78.0
      ],
      [
        630.0,
        487.2720031738281,
        78.0
      ],
      [
        659.0,
        516.2720947265625,
        78.0
      ],
      [
        659.0,
        514.8578491210938,
        78.0
      ],
      [
        620.0,
        560.0,
        78.0
      ],
      [
        620.0,
        560.0,
        80.0
      ],
      [
        620.0,
        560.0,
        78.0
      ],
      [
        740.0,
        676.1422729492188,
        78.0
      ],
      [
        620.0,
        590.0,
        60.0
      ],
      [
        620.0,
        604.1421508789062,
        80.0
      ],
      [
        620.0,
        930.0,
        60.0
      ],
      [
        620.0,
        920.0,
        80.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        721.0000610351562,
        657.1422729492188,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        720.0,
        656.1539306640625,
        80.0
      ],
      [
        620.0,
        750.0,
        100.0
      ],
      [
        620.0,
        750.0,
        140.0
      ],
      [
        620.0,
        750.0,
        140.0
      ],
      [
        620.0,
        750.0,
        240.0
      ],
      [
        620.0,
        920.0,
        240.0
      ],
      [
        620.0,
        820.0,
        240.0
      ],
      [
        620.0,
        820.0,
        240.0
      ],
      [
        620.0,
        750.0,
        240.0
      ],
      [
        670.7326049804688,
        555.0899658203125,
        100.0
      ],
      [
        670.7326049804688,
        555.0900268554688,
        98.0
      ],
      [
        670.7326049804688,
        555.0899658203125,
        98.0
      ],
      [
        670.7326049804688,
        555.0900268554688,
        100.0
      ],
      [
        668.3988037109375,
        566.8431396484375,
        100.0
      ],
      [
        663.6920776367188,
        571.5499267578125,
        100.0
      ],
      [
        668.3988647460938,
        566.8431396484375,
        100.0
      ],
      [
        670.76318359375,
        564.4789428710938,
        100.0
      ],
      [
        666.0545654296875,
        559.7703857421875,
        98.0
      ],
      [
        666.0545654296875,
        559.7703247070312,
        100.0
      ],
      [
        666.0545654296875,
        559.7703247070312,
        98.0
      ],
      [
        666.0545654296875,
        559.7703857421875,
        100.0
      ],
      [
        677.8142700195312,
        562.1563720703125,
        100.0
      ],
      [
        677.8394165039062,
        562.1814575195312,
        99.9787368774414
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        980.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        620.0,
        979.0,
        78.0
      ],
      [
        360.0,
        970.0,
        60.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        140.0
      ],
      [
        539.9170532226562,
        879.8848876953125,
        460.0
      ],
      [
        360.0,
        540.0,
        80.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        360.0,
        540.0,
        80.0
      ],
      [
        360.0,
        540.0,
        78.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        540.0,
        78.0
      ],
      [
        456.27862548828125,
        511.0,
        78.0
      ],
      [
        360.0,
        511.0,
        78.0
      ],
      [
        620.0,
        511.0,
        78.0
      ],
      [
        523.7213745117188,
        511.0,
        78.0
      ],
      [
        400.5368347167969,
        400.0,
        78.0
      ],
      [
        417.6227722167969,
        452.5851135253906,
        78.0
      ],
      [
        417.6227722167969,
        347.4148864746094,
        78.0
      ],
      [
        400.5368347167969,
        400.0,
        78.0
      ],
      [
        579.4631958007812,
        400.0,
        78.0
      ],
      [
        562.3772583007812,
        347.4148864746094,
        78.0
      ],
      [
        562.3772583007812,
        452.5851135253906,
        78.0
      ],
      [
        579.4631958007812,
        400.0,
        78.0
      ],
      [
        562.3772583007812,
        347.4148864746094,
        78.0
      ],
      [
        523.7213745117188,
        319.3297424316406,
        78.0
      ],
      [
        523.7213745117188,
        319.3297424316406,
        78.0
      ],
      [
        523.7213745117188,
        280.5788269042969,
        78.0
      ],
      [
        523.7213745117188,
        318.8202209472656,
        78.0
      ],
      [
        523.7213745117188,
        300.0,
        78.0
      ],
      [
        500.0,
        300.0,
        80.0
      ],
      [
        500.0,
        300.0,
        78.0
      ],
      [
        500.0,
        300.85906982421875,
        80.0
      ],
      [
        500.0,
        302.0951232910156,
        78.0
      ],
      [
        523.0200805664062,
        318.8202209472656,
        78.0
      ],
      [
        456.27862548828125,
        319.3297424316406,
        78.0
      ],
      [
        417.6227722167969,
        347.4148864746094,
        78.0
      ],
      [
        456.27862548828125,
        274.18280029296875,
        78.0
      ],
      [
        456.27862548828125,
        319.3297424316406,
        78.0
      ],
      [
        456.27862548828125,
        318.8202209472656,
        78.0
      ],
      [
        480.0,
        300.0,
        78.0
      ],
      [
        480.0,
        300.0,
        80.0
      ],
      [
        456.27862548828125,
        300.0,
        78.0
      ],
      [
        480.0,
        302.0951843261719,
        78.0
      ],
      [
        480.0,
        300.8591003417969,
        80.0
      ],
      [
        456.9800109863281,
        318.8202209472656,
        78.0
      ],
      [
        523.7213745117188,
        480.6702575683594,
        78.0
      ],
      [
        562.3772583007812,
        452.5851135253906,
        78.0
      ],
      [
        523.7213745117188,
        511.0,
        78.0
      ],
      [
        523.7213745117188,
        480.6702575683594,
        78.0
      ],
      [
        523.7213745117188,
        481.1797790527344,
        78.0
      ],
      [
        500.0,
        511.0,
        78.0
      ],
      [
        500.0,
        497.9048156738281,
        78.0
      ],
      [
        500.0,
        499.1409912109375,
        80.0
      ],
      [
        500.0,
        510.0,
        80.0
      ],
      [
        523.0200805664062,
        481.1797790527344,
        78.0
      ],
      [
        417.6227722167969,
        452.5851135253906,
        78.0
      ],
      [
        456.27862548828125,
        480.6702575683594,
        78.0
      ],
      [
        456.27862548828125,
        480.6702575683594,
        78.0
      ],
      [
        456.27862548828125,
        511.0,
        78.0
      ],
      [
        456.27862548828125,
        481.1797790527344,
        78.0
      ],
      [
        480.0,
        510.0,
        80.0
      ],
      [
        480.0,
        499.1408996582031,
        80.0
      ],
      [
        480.0,
        497.90484619140625,
        78.0
      ],
      [
        480.0,
        511.0,
        78.0
      ],
      [
        456.9799499511719,
        481.1797790527344,
        78.0
      ],
      [
        497.1163024902344,
        300.0,
        78.0
      ],
      [
        481.8045654296875,
        300.0,
        60.0
      ],
      [
        360.0,
        570.0,
        60.0
      ],
      [
        550.0,
        579.0,
        78.0
      ],
      [
        570.0,
        579.0,
        78.0
      ],
      [
        550.0,
        579.0,
        78.0
      ],
      [
        570.0,
        579.0,
        78.0
      ],
      [
        521.5,
        792.0,
        80.0
      ],
      [
        521.5,
        818.0,
        80.0
      ],
      [
        532.1206665039062,
        808.0476684570312,
        65.0
      ],
      [
        532.1715698242188,
        805.149658203125,
        65.0
      ],
      [
        532.2655029296875,
        799.7999877929688,
        65.0
      ],
      [
        532.4025268554688,
        792.0,
        65.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        240.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        260.0
      ],
      [
        410.03387451171875,
        750.0,
        360.0
      ],
      [
        410.03387451171875,
        750.0,
        460.0
      ],
      [
        410.03387451171875,
        750.0,
        360.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        240.0
      ],
      [
        584.9010009765625,
        834.9010009765625,
        240.0
      ],
      [
        609.9010009765625,
        809.9010009765625,
        240.0
      ],
      [
        609.9010009765625,
        809.9010009765625,
        240.0
      ],
      [
        620.0,
        799.8020629882812,
        240.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        553.146240234375,
        750.0,
        80.0
      ],
      [
        559.7156982421875,
        750.0,
        80.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        449.9999694824219,
        580.0,
        240.0
      ],
      [
        379.9999694824219,
        510.0,
        220.0
      ],
      [
        379.9999694824219,
        510.0,
        80.0
      ],
      [
        360.0,
        490.0,
        220.0
      ],
      [
        379.9999694824219,
        510.0,
        220.0
      ],
      [
        380.0,
        510.0,
        220.0
      ],
      [
        360.0,
        490.0000305175781,
        220.0
      ],
      [
        550.0,
        680.0,
        100.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        450.0,
        580.0,
        240.0
      ],
      [
        449.9999694824219,
        580.0,
        160.0
      ],
      [
        449.9999694824219,
        580.0,
        140.0
      ],
      [
        450.0,
        580.0,
        160.0
      ],
      [
        449.9999694824219,
        580.0,
        80.0
      ],
      [
        449.9999694824219,
        580.0,
        140.0
      ],
      [
        550.0,
        746.853759765625,
        80.0
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        80.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        90.00000762939453
      ],
      [
        580.8578491210938,
        739.1421508789062,
        90.00000762939453
      ],
      [
        550.0,
        580.0,
        220.0
      ],
      [
        450.0,
        580.0,
        220.0
      ],
      [
        550.0,
        580.0,
        220.0
      ],
      [
        550.0,
        680.0,
        220.0
      ],
      [
        455.27862548828125,
        343.5415954589844,
        118.0
      ],
      [
        455.27862548828125,
        456.4584045410156,
        118.0
      ],
      [
        455.27862548828125,
        343.5415954589844,
        120.0
      ],
      [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      [
        455.27862548828125,
        343.5415954589844,
        118.0
      ],
      [
        455.27862548828125,
        343.5415954589844,
        120.0
      ],
      [
        455.27862548828125,
        456.4584045410156,
        118.0
      ],
      [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      [
        524.7213745117188,
        500.0,
        120.0
      ],
      [
        524.7213745117188,
        500.0,
        130.0
      ],
      [
        524.7213745117188,
        500.0,
        80.0
      ],
      [
        524.7213745117188,
        500.0,
        120.0
      ],
      [
        524.7213745117188,
        500.0,
        215.0
      ],
      [
        524.7213745117188,
        500.0,
        130.0
      ],
      [
        559.7213745117188,
        500.0,
        145.0
      ],
      [
        600.0,
        500.0,
        145.0
      ],
      [
        600.0,
        500.0,
        130.0
      ],
      [
        559.7213745117188,
        500.0,
        130.0
      ],
      [
        600.0,
        500.0,
        145.0
      ],
      [
        600.0,
        500.0,
        130.0
      ],
      [
        559.7213745117188,
        500.0,
        145.0
      ],
      [
        559.7213745117188,
        500.0,
        130.0
      ],
      [
        524.7213745117188,
        500.0,
        215.0
      ],
      [
        455.27862548828125,
        500.0,
        215.0
      ],
      [
        549.6473388671875,
        495.0,
        127.12169647216797
      ],
      [
        552.896484375,
        485.0,
        128.05003356933594
      ],
      [
        549.6473388671875,
        495.0,
        127.1217041015625
      ],
      [
        549.6473388671875,
        495.0,
        130.0
      ],
      [
        552.896484375,
        485.0,
        128.05003356933594
      ],
      [
        552.896484375,
        485.0,
        130.0
      ],
      [
        590.0,
        450.0,
        145.0
      ],
      [
        615.0,
        450.0,
        145.0
      ],
      [
        590.0,
        452.1875,
        145.0
      ],
      [
        590.0,
        450.0,
        145.0
      ],
      [
        615.0,
        450.0,
        145.0
      ],
      [
        615.0,
        452.1875,
        145.0
      ],
      [
        605.0,
        460.0,
        145.0
      ],
      [
        605.0,
        467.8125,
        145.0
      ],
      [
        590.0,
        472.5,
        145.0
      ],
      [
        600.0,
        472.5,
        145.0
      ],
      [
        600.0,
        472.5,
        145.0
      ],
      [
        600.0,
        460.0,
        145.0
      ],
      [
        600.0,
        460.0,
        145.0
      ],
      [
        605.0,
        460.0,
        145.0
      ],
      [
        590.0,
        460.0,
        145.0
      ],
      [
        590.0,
        460.0,
        145.0
      ],
      [
        590.0,
        472.5,
        145.0
      ],
      [
        615.0,
        460.0,
        145.0
      ],
      [
        615.0,
        460.0,
        145.0
      ],
      [
        615.0,
        467.8125,
        145.0
      ],
      [
        615.0,
        495.0,
        166.0
      ],
      [
        615.0,
        495.0,
        166.0
      ],
      [
        615.0,
        495.0,
        156.0
      ],
      [
        615.0,
        495.0,
        156.0
      ],
      [
        605.0,
        467.8125,
        145.0
      ],
      [
        615.0,
        467.8125,
        145.0
      ],
      [
        605.0,
        495.0,
        162.40000915527344
      ],
      [
        615.0,
        495.0,
        162.40000915527344
      ],
      [
        552.896484375,
        485.0,
        138.05003356933594
      ],
      [
        590.0,
        450.0,
        144.00001525878906
      ],
      [
        615.0,
        450.0,
        144.00001525878906
      ],
      [
        590.0,
        450.0,
        144.00001525878906
      ],
      [
        615.0,
        450.0,
        144.00001525878906
      ],
      [
        552.896484375,
        485.0,
        138.05003356933594
      ],
      [
        549.6473388671875,
        495.0,
        137.1217041015625
      ],
      [
        549.6473388671875,
        495.0,
        137.1217041015625
      ],
      [
        498.817626953125,
        500.0,
        118.0
      ],
      [
        498.817626953125,
        500.0,
        215.0
      ],
      [
        498.817626953125,
        500.0,
        120.0
      ],
      [
        498.8175964355469,
        500.0,
        185.0
      ],
      [
        512.5814208984375,
        490.0,
        185.0
      ],
      [
        512.5814208984375,
        490.0,
        185.0
      ],
      [
        512.5814208984375,
        490.0,
        195.0
      ],
      [
        498.8175964355469,
        500.0,
        155.0
      ],
      [
        512.5814208984375,
        490.0,
        155.0
      ],
      [
        512.5814208984375,
        490.0,
        155.0
      ],
      [
        512.5814208984375,
        490.0,
        165.0
      ],
      [
        505.6996154785156,
        495.0,
        95.5
      ],
      [
        505.6996154785156,
        495.0,
        100.0
      ],
      [
        498.8175964355469,
        500.0,
        95.5
      ],
      [
        505.6996154785156,
        495.0,
        95.5
      ],
      [
        505.6996154785156,
        495.0,
        100.0
      ],
      [
        498.8175964355469,
        500.0,
        100.0
      ],
      [
        498.81756591796875,
        300.0,
        120.0
      ],
      [
        498.81756591796875,
        300.0,
        130.0
      ],
      [
        498.81756591796875,
        300.0,
        80.0
      ],
      [
        498.81756591796875,
        300.0,
        90.0
      ],
      [
        498.81756591796875,
        300.0,
        155.0
      ],
      [
        498.81756591796875,
        300.0,
        159.5
      ],
      [
        498.81756591796875,
        300.0,
        155.0
      ],
      [
        498.81756591796875,
        300.0,
        130.0
      ],
      [
        498.81756591796875,
        300.0,
        118.0
      ],
      [
        498.81756591796875,
        300.0,
        90.0
      ],
      [
        498.81756591796875,
        300.0,
        95.5
      ],
      [
        498.81756591796875,
        300.0,
        100.0
      ],
      [
        498.81756591796875,
        300.0,
        100.0
      ],
      [
        498.8175354003906,
        300.0,
        118.0
      ],
      [
        498.8175354003906,
        300.0,
        185.0
      ],
      [
        498.8175354003906,
        300.0,
        195.0
      ],
      [
        498.8175354003906,
        300.0,
        155.0
      ],
      [
        498.8175354003906,
        300.0,
        165.0
      ],
      [
        498.8175354003906,
        300.0,
        159.5
      ],
      [
        498.8175354003906,
        300.0,
        215.0
      ],
      [
        498.8175354003906,
        300.0,
        215.0
      ],
      [
        498.8175354003906,
        300.0,
        159.5
      ],
      [
        465.9249267578125,
        276.10211181640625,
        220.0
      ],
      [
        465.9248962402344,
        276.1020812988281,
        215.0
      ],
      [
        498.81756591796875,
        300.0,
        215.0
      ],
      [
        465.9248962402344,
        276.1020812988281,
        215.0
      ],
      [
        524.7213745117188,
        300.0,
        215.0
      ],
      [
        495.0,
        297.2264099121094,
        90.0
      ],
      [
        495.0,
        297.2264099121094,
        80.0
      ],
      [
        495.0,
        297.2264099121094,
        120.0
      ],
      [
        495.0,
        297.2264099121094,
        130.0
      ],
      [
        495.0,
        297.2264099121094,
        90.0
      ],
      [
        495.0,
        297.2264099121094,
        120.0
      ],
      [
        505.0,
        300.0,
        120.0
      ],
      [
        505.0,
        300.0,
        118.0
      ],
      [
        505.0,
        300.0,
        120.0
      ],
      [
        505.0,
        300.0,
        118.0
      ],
      [
        495.0,
        280.0,
        118.0
      ],
      [
        495.0,
        280.0,
        120.0
      ],
      [
        480.0,
        286.3282775878906,
        120.0
      ],
      [
        480.0,
        286.3282775878906,
        118.0
      ],
      [
        485.0,
        289.9609375,
        80.0
      ],
      [
        485.0,
        289.9609375,
        90.0
      ],
      [
        485.0,
        289.9609375,
        120.0
      ],
      [
        485.0,
        289.9609375,
        130.0
      ],
      [
        485.0,
        289.9609375,
        90.0
      ],
      [
        485.0,
        289.9609375,
        120.0
      ],
      [
        485.0,
        289.9609375,
        130.0
      ],
      [
        495.0,
        297.2264099121094,
        130.0
      ],
      [
        505.6994934082031,
        305.0,
        155.0
      ],
      [
        505.6994934082031,
        305.0,
        118.0
      ],
      [
        505.6994934082031,
        305.0,
        100.0
      ],
      [
        505.6994934082031,
        305.0,
        95.5
      ],
      [
        505.699462890625,
        305.0,
        118.0
      ],
      [
        505.6994934082031,
        305.0,
        100.0
      ],
      [
        505.0,
        304.4917907714844,
        155.0
      ],
      [
        505.0,
        304.4917907714844,
        118.0
      ],
      [
        505.0,
        304.4917907714844,
        120.0
      ],
      [
        505.0,
        304.4917907714844,
        118.0
      ],
      [
        505.699462890625,
        305.0,
        155.0
      ],
      [
        505.0,
        304.4918212890625,
        155.0
      ],
      [
        505.0,
        300.0,
        155.0
      ],
      [
        524.7213745117188,
        305.0,
        155.0
      ],
      [
        505.699462890625,
        305.0,
        185.0
      ],
      [
        505.0,
        304.4918212890625,
        185.0
      ],
      [
        505.0,
        300.0,
        185.0
      ],
      [
        524.7213745117188,
        305.0,
        185.0
      ],
      [
        505.699462890625,
        305.0,
        215.0
      ],
      [
        505.0,
        304.4918212890625,
        215.0
      ],
      [
        505.0,
        300.0,
        215.0
      ],
      [
        524.7213745117188,
        305.0,
        215.0
      ],
      [
        505.6994934082031,
        305.0,
        95.5
      ],
      [
        505.0,
        304.4917907714844,
        95.5
      ],
      [
        505.0,
        300.0,
        95.5
      ],
      [
        505.0,
        304.4917907714844,
        155.0
      ],
      [
        498.81756591796875,
        300.0,
        155.0
      ],
      [
        498.8175354003906,
        300.0,
        155.0
      ],
      [
        498.8175354003906,
        300.0,
        185.0
      ],
      [
        498.81756591796875,
        300.0,
        95.5
      ],
      [
        500.0,
        300.85906982421875,
        120.0
      ],
      [
        498.81756591796875,
        300.0,
        120.0
      ],
      [
        500.0,
        300.85906982421875,
        120.0
      ],
      [
        505.0,
        304.4917907714844,
        120.0
      ],
      [
        500.0,
        300.85906982421875,
        118.0
      ],
      [
        498.81756591796875,
        300.0,
        118.0
      ],
      [
        505.0,
        304.4917907714844,
        118.0
      ],
      [
        500.0,
        300.85906982421875,
        118.0
      ],
      [
        512.5813598632812,
        310.0,
        185.0
      ],
      [
        512.5813598632812,
        310.0,
        195.0
      ],
      [
        512.5813598632812,
        310.0,
        185.0
      ],
      [
        512.5813598632812,
        310.0,
        155.0
      ],
      [
        512.5813598632812,
        310.0,
        165.0
      ],
      [
        512.5813598632812,
        310.0,
        155.0
      ],
      [
        455.27862548828125,
        300.0,
        215.0
      ],
      [
        498.81756591796875,
        300.0,
        215.0
      ],
      [
        480.0,
        305.0,
        120.0
      ],
      [
        480.0,
        305.0,
        118.0
      ],
      [
        505.0,
        305.0,
        120.0
      ],
      [
        505.0,
        305.0,
        118.0
      ],
      [
        480.0,
        305.0,
        120.0
      ],
      [
        500.0,
        305.0,
        120.0
      ],
      [
        500.0,
        305.0,
        120.0
      ],
      [
        505.0,
        305.0,
        120.0
      ],
      [
        500.0,
        305.0,
        118.0
      ],
      [
        480.0,
        305.0,
        118.0
      ],
      [
        505.0,
        305.0,
        118.0
      ],
      [
        500.0,
        305.0,
        118.0
      ],
      [
        480.0,
        310.0,
        120.0
      ],
      [
        500.0,
        310.0,
        120.0
      ],
      [
        500.0,
        310.0,
        120.0
      ],
      [
        505.0,
        310.0,
        120.0
      ],
      [
        500.0,
        310.0,
        118.0
      ],
      [
        480.0,
        310.0,
        118.0
      ],
      [
        505.0,
        310.0,
        118.0
      ],
      [
        500.0,
        310.0,
        118.0
      ],
      [
        480.0,
        310.0,
        120.0
      ],
      [
        480.0,
        310.0,
        118.0
      ],
      [
        505.0,
        310.0,
        120.0
      ],
      [
        505.0,
        310.0,
        118.0
      ],
      [
        610.132080078125,
        930.0,
        60.0
      ],
      [
        600.1320190429688,
        920.0,
        80.0
      ],
      [
        590.0321655273438,
        930.0,
        60.0
      ],
      [
        580.0322265625,
        920.0,
        80.0
      ],
      [
        360.0,
        930.0,
        60.0
      ],
      [
        489.8018798828125,
        930.0,
        60.0
      ],
      [
        499.802001953125,
        920.0,
        80.0
      ],
      [
        310.0,
        979.0,
        78.0
      ],
      [
        330.0,
        980.0,
        80.0
      ],
      [
        330.0,
        979.0,
        78.0
      ],
      [
        360.0,
        979.0,
        78.0
      ],
      [
        360.0,
        921.0,
        78.0
      ],
      [
        359.0,
        921.0,
        78.0
      ],
      [
        359.0,
        579.0,
        78.0
      ],
      [
        360.0,
        579.0,
        78.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -4582.1171875,
      "bbox_min": [
        -4714.78125,
        0.0,
        -3000.0
      ],
      "bbox_max": [
        950.0,
        1600.0,
        0.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3210.00390625,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3210.00390625,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3408.73486328125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        960.6837768554688
      ],
      "bbox_max": [
        -3000.0,
        -3527.920166015625,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        960.6837768554688
      ],
      "bbox_max": [
        -3000.0,
        -3527.920166015625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -3000.0,
      "bbox_min": [
        -5072.0185546875,
        0.0,
        400.0
      ],
      "bbox_max": [
        -1550.0,
        1852.5999755859375,
        0.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -2881.897705078125,
        -5072.0185546875,
        1219.6473388671875
      ],
      "bbox_max": [
        -2147.99658203125,
        -4709.201171875,
        1390.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4769039750099182,
        0.7969357371330261,
        0.37075066566467285
      ],
      "plane_d": 1317.8310546875,
      "bbox_min": [
        -2860.521728515625,
        -3623.86962890625,
        0.0
      ],
      "bbox_max": [
        -1550.0,
        -2671.68505859375,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2860.521728515625,
        -3539.687744140625,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -2860.521728515625,
        -3539.687744140625,
        11.2554931640625
      ],
      "bbox_max": [
        -2100.0,
        -3114.76806640625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3108.556396484375,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3108.556396484375,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        1191.9580078125
      ],
      "bbox_max": [
        -2880.93603515625,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2861.24462890625,
        -3114.76806640625,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3108.556396484375,
        11.255549430847168
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -1100.0,
        -2100.0,
        0.0
      ],
      "bbox_max": [
        -800.0,
        -1452.5167236328125,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2100.0,
        287.1609191894531
      ],
      "bbox_max": [
        -800.0,
        -1855.504150390625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        6871.484375,
        100.0
      ],
      "bbox_max": [
        -800.0,
        7251.08740234375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -2708.39404296875,
        6871.484375,
        140.0
      ],
      "bbox_max": [
        -800.0,
        7251.08740234375,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        -800.0,
        5034.5224609375,
        -33.027774810791016
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        -800.0,
        6871.484375,
        -22.699951171875
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -800.0,
        7251.08740234375,
        -22.699951171875
      ],
      "bbox_max": [
        200.0,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05136118829250336,
        -0.319204717874527,
        0.9462930560112
      ],
      "plane_d": 1763.4461669921875,
      "bbox_min": [
        -800.0,
        5034.5224609375,
        0.0
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        816.3760375976562,
        6871.484375,
        547.115966796875
      ],
      "bbox_max": [
        3108.39404296875,
        7327.39501953125,
        652.46484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509035348892212,
        -0.9807853102684021,
        0.0
      ],
      "plane_d": 7267.83251953125,
      "bbox_min": [
        -800.0,
        7251.08740234375,
        608.452392578125
      ],
      "bbox_max": [
        200.0,
        7450.0,
        976.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6543579101562,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        329.84539794921875
      ],
      "bbox_max": [
        7550.0,
        -1319.93994140625,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1700.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        590.90966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1390.916015625,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2300.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027094179764389992,
        0.9482963681221008,
        0.31622782349586487
      ],
      "plane_d": 817.0990600585938,
      "bbox_min": [
        650.0,
        -843.0780639648438,
        -300.0
      ],
      "bbox_max": [
        2273.75537109375,
        -696.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -800.0,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -800.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18530525267124176,
        0.5702676773071289,
        0.8002853393554688
      ],
      "plane_d": 680.0791625976562,
      "bbox_min": [
        -800.0,
        -1855.504150390625,
        0.0
      ],
      "bbox_max": [
        -551.24462890625,
        -1371.68505859375,
        287.160888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        -551.24462890625,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14309725165367126,
        0.2930086553096771,
        0.9453407526016235
      ],
      "plane_d": 323.03399658203125,
      "bbox_min": [
        -551.24462890625,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        499.2938232421875,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161502480506897
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        523.75537109375,
        -867.0938720703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        16.99639320373535
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        -400.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        2091.7158203125,
        1710.0,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1290.0,
        538.75,
        60.0
      ],
      "bbox_max": [
        2091.7158203125,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1469.9998779296875,
      "bbox_min": [
        1290.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        2091.7158203125,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1770.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        0.24771343171596527,
        0.0
      ],
      "plane_d": 1538.40771484375,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        500.0
      ],
      "bbox_max": [
        2020.0,
        1690.1553955078125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1631.8814697265625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1631.8814697265625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1624.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      "bbox_max": [
        1917.370849609375,
        1643.306640625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1579.9000244140625,
      "bbox_min": [
        1770.0,
        1579.9000244140625,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1840.0,
        1579.9000244140625,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1909.7445068359375,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1290.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1290.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1400.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1455.4544677734375,
        960.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1528.181884765625,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1528.181884765625,
        1270.0,
        630.1036376953125
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1455.4544677734375,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1541.0,
        1398.181884765625,
        711.67822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1460.9998779296875,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1541.0,
        1270.0,
        630.1036376953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1400.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1460.9998779296875,
        1325.4544677734375,
        608.8261108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1400.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1460.9998779296875,
        1325.4544677734375,
        608.8261108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1270.0,
      "bbox_min": [
        1400.0,
        1270.0,
        490.0
      ],
      "bbox_max": [
        1460.9998779296875,
        1270.0,
        573.5350341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1405.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1290.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1130.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1030.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1290.0,
        1050.0,
        160.0
      ],
      "bbox_max": [
        1390.0,
        1050.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1600.0,
        720.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        900.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        538.75,
        100.0
      ],
      "bbox_max": [
        1600.0,
        720.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1290.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        720.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1290.0,
        670.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        720.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1290.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1350.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1350.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        1290.0,
        1710.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1450.0,
      "bbox_min": [
        440.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        1175.0,
        1710.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1570.0,
      "bbox_min": [
        450.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        450.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        450.0,
        1640.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        195.16659545898438
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        660.0,
        1640.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        685.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        720.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        190.0
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1690.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1710.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        720.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        1083.078369140625,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1057.5947265625,
      "bbox_min": [
        720.0,
        1580.0,
        60.0
      ],
      "bbox_max": [
        1083.078369140625,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707106351852417,
        0.0,
        0.7071071863174438
      ],
      "plane_d": 533.21337890625,
      "bbox_min": [
        1057.5947265625,
        1610.0,
        303.5163879394531
      ],
      "bbox_max": [
        1083.078369140625,
        1690.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        720.0,
        1580.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        790.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1670.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        790.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1670.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        790.0,
        1661.428466796875,
        100.0
      ],
      "bbox_max": [
        794.2857666015625,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        790.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        820.0,
        1663.9998779296875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1690.0,
        216.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        780.0,
        1580.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 1833.31982421875,
      "bbox_min": [
        780.0,
        1664.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1670.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        1580.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1580.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        721.0,
        1580.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        740.0,
        1580.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1690.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        720.0,
        1580.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        720.0,
        1580.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        720.0,
        1580.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1670.0,
      "bbox_min": [
        720.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1675.84326171875,
      "bbox_min": [
        720.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        806.0,
        1580.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.5144957304000854,
        0.0
      ],
      "plane_d": 121.763916015625,
      "bbox_min": [
        800.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        806.0,
        1580.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        720.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        780.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        790.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1580.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        720.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        760.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        780.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        760.0,
        1580.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        721.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        740.0,
        1570.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        500.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        500.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        640.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1460.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        960.0,
        1570.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        780.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        780.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        820.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        780.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        820.0,
        1540.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        780.0,
        1530.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1530.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1570.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1459.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        720.0,
        1450.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1459.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        720.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        721.0,
        1450.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1570.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        740.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        440.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1420.0,
      "bbox_min": [
        500.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1450.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        720.0,
        1420.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        1420.0,
        78.0
      ],
      "bbox_max": [
        820.0,
        1450.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -740.0,
      "bbox_min": [
        740.0,
        1440.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1450.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        500.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        500.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        1420.0,
        78.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        500.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -730.0,
      "bbox_min": [
        730.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1400.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        615.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1150.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        760.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1420.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1170.0,
        72.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1420.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        760.0,
        1170.0,
        78.0
      ],
      "bbox_max": [
        905.0,
        1420.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        1170.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1420.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        78.0
      ],
      "bbox_max": [
        790.0,
        1310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        760.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        780.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        905.0,
        1320.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1170.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        790.0,
        1310.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        440.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        440.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1324.3714599609375,
      "bbox_min": [
        510.5146179199219,
        1280.0,
        140.0
      ],
      "bbox_max": [
        719.4853515625,
        1324.3714599609375,
        550.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5877838730812073,
        -0.809018075466156,
        -0.0
      ],
      "plane_d": 1440.44677734375,
      "bbox_min": [
        510.5146179199219,
        1280.0,
        140.0
      ],
      "bbox_max": [
        719.4853515625,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        717.8607788085938,
        1280.0,
        140.0
      ],
      "bbox_max": [
        719.4853515625,
        1285.0,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9510567784309387,
        -0.3090161681175232,
        0.0
      ],
      "plane_d": -148.44259643554688,
      "bbox_min": [
        510.5146179199219,
        1280.0,
        160.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        510.5146179199219,
        1280.0,
        160.0
      ],
      "bbox_max": [
        512.1392211914062,
        1285.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877826809883118,
        -0.8090188503265381,
        0.0
      ],
      "plane_d": 717.474365234375,
      "bbox_min": [
        581.5086059570312,
        1280.0,
        160.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 518.0,
      "bbox_min": [
        602.2073974609375,
        1280.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.3714599609375,
      "bbox_min": [
        602.2073974609375,
        1280.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        612.5,
        1300.3714599609375,
        518.0
      ],
      "bbox_max": [
        620.0,
        1324.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 612.5,
      "bbox_min": [
        612.5,
        1300.3714599609375,
        518.0
      ],
      "bbox_max": [
        612.5,
        1300.4000244140625,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 612.5,
      "bbox_min": [
        612.5,
        1280.0,
        518.0
      ],
      "bbox_max": [
        612.5,
        1300.3714599609375,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        780.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": 452.5483703613281,
      "bbox_min": [
        780.0,
        1310.0,
        140.0
      ],
      "bbox_max": [
        820.0,
        1450.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        440.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        512.1392211914062,
        1185.6285400390625,
        140.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        512.1392211914062,
        1185.6285400390625,
        140.0
      ],
      "bbox_max": [
        717.8607788085938,
        1280.0,
        550.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        512.1392211914062,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        660.2877197265625,
        1280.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 627.7926025390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        660.2877197265625,
        1280.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        550.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 535.0,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        500.0
      ],
      "bbox_max": [
        660.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1235.0,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        500.0
      ],
      "bbox_max": [
        643.2877197265625,
        1235.0,
        535.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6250033378601074,
        0.7806220650672913
      ],
      "plane_d": 335.09832763671875,
      "bbox_min": [
        627.7926025390625,
        1185.6285400390625,
        500.0
      ],
      "bbox_max": [
        643.2877197265625,
        1225.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        627.7926025390625,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7999877929688,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        627.7926025390625,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7999877929688,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6250033378601074,
        -0.7806220650672913
      ],
      "plane_d": -331.975830078125,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -635.7925415039062,
      "bbox_min": [
        635.7926025390625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 643.2876586914062,
      "bbox_min": [
        643.2877197265625,
        1185.6285400390625,
        520.0
      ],
      "bbox_max": [
        643.2877197265625,
        1190.0,
        527.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -602.2073974609375,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        627.7926025390625,
        1280.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1185.6285400390625,
      "bbox_min": [
        582.7122802734375,
        1185.6285400390625,
        160.0
      ],
      "bbox_max": [
        602.2073974609375,
        1225.0,
        550.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        602.2000122070312,
        1222.0,
        500.0
      ],
      "bbox_max": [
        602.2073974609375,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        602.2000122070312,
        1222.0,
        500.0
      ],
      "bbox_max": [
        602.2073974609375,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1225.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        446.5
      ],
      "bbox_max": [
        627.7926025390625,
        1280.0,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 612.5,
      "bbox_min": [
        612.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1280.0,
        520.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 518.0,
      "bbox_min": [
        612.5,
        1225.0,
        518.0
      ],
      "bbox_max": [
        627.7926025390625,
        1280.0,
        518.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7926025390625,
        1225.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1222.0,
      "bbox_min": [
        602.2073974609375,
        1222.0,
        500.0
      ],
      "bbox_max": [
        627.7926025390625,
        1222.0,
        501.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        440.0,
        1130.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        1130.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 805.3590087890625,
      "bbox_min": [
        805.3590087890625,
        1190.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        -0.8660252690315247,
        -0.0
      ],
      "plane_d": 1452.3023681640625,
      "bbox_min": [
        805.3590087890625,
        1190.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        340.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        840.0,
        1190.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        910.0,
        1232.41455078125,
        140.0
      ],
      "bbox_max": [
        910.0,
        1280.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 910.0,
      "bbox_min": [
        910.0,
        1190.0,
        140.0
      ],
      "bbox_max": [
        910.0,
        1232.41455078125,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565400123596,
        -0.30901700258255005,
        0.0
      ],
      "plane_d": -287.18438720703125,
      "bbox_min": [
        647.2877197265625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        730.0,
        1285.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 578.7291259765625,
      "bbox_min": [
        647.2877197265625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        699.5303955078125,
        1223.5849609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        647.2877197265625,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        699.5303955078125,
        1223.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506506085395813,
        -0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": -301.5865478515625,
      "bbox_min": [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        730.0,
        1285.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257304906845093,
        -0.7236071825027466,
        0.44721391797065735
      ],
      "plane_d": 472.9090270996094,
      "bbox_min": [
        694.2730712890625,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        708.0369262695312,
        1223.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        760.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        990.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.0,
        -0.44721364974975586
      ],
      "plane_d": 742.3746948242188,
      "bbox_min": [
        760.0,
        1150.0,
        80.0
      ],
      "bbox_max": [
        820.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        820.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        820.0,
        1400.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1309.9998779296875,
      "bbox_min": [
        780.0,
        1310.0,
        120.0
      ],
      "bbox_max": [
        820.0,
        1310.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1310.0,
        100.0
      ],
      "bbox_max": [
        780.0,
        1320.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1320.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        780.0,
        1310.0,
        80.0
      ],
      "bbox_max": [
        790.0,
        1310.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        780.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        990.0,
        1180.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        780.0,
        1180.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        1290.0,
        1130.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        1290.0,
        1130.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        1290.0,
        1080.8577880859375,
        810.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1250.0,
        620.0,
        60.0
      ],
      "bbox_max": [
        1290.0,
        1050.0,
        350.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1250.0,
        750.0,
        160.0
      ],
      "bbox_max": [
        1290.0,
        1050.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1250.0,
        750.0,
        188.5
      ],
      "bbox_max": [
        1280.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 764.0,
      "bbox_min": [
        1250.0,
        764.0,
        188.5
      ],
      "bbox_max": [
        1252.0,
        764.0,
        193.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 258.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1260.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1080.8577880859375,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1080.8577880859375,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        505.85784912109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        505.85784912109375,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        78.0
      ],
      "bbox_max": [
        650.0,
        485.8578186035156,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        630.0,
        281.61761474609375,
        78.0
      ],
      "bbox_max": [
        650.0,
        283.51434326171875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.672899067401886,
        0.7397342920303345,
        0.0
      ],
      "plane_d": -632.2486572265625,
      "bbox_min": [
        620.0,
        281.61761474609375,
        78.0
      ],
      "bbox_max": [
        630.0,
        290.714111328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        621.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        289.8044738769531,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.672899067401886,
        0.7397342920303345,
        0.0
      ],
      "plane_d": -632.2486572265625,
      "bbox_min": [
        621.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        630.0,
        289.8044738769531,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        620.0,
        281.61761474609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        624.1422119140625,
        480.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        650.0,
        283.51434326171875,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        320.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 856.760986328125,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        320.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 304.0712890625,
      "bbox_min": [
        856.760986328125,
        304.0712890625,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        304.0712890625,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 268.32818603515625,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 299.9999694824219,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -735.0,
      "bbox_min": [
        735.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        735.0,
        310.0,
        67.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        760.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        650.0,
        320.0,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1080.8577880859375,
        810.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        650.0,
        320.0,
        60.0
      ],
      "bbox_max": [
        1230.0,
        930.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        707.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        650.0,
        320.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        320.0,
        60.0
      ],
      "bbox_max": [
        765.0,
        515.8578491210938,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        658.9999389648438,
        320.0,
        78.0
      ],
      "bbox_max": [
        765.0,
        354.4642639160156,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        658.9999389648438,
        320.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -344.5075988769531,
      "bbox_min": [
        658.9999389648438,
        344.507568359375,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        650.0,
        324.60308837890625,
        78.0
      ],
      "bbox_max": [
        660.0,
        344.5075988769531,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        844.1421508789062,
        700.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        851.8724365234375,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1210.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        851.8724365234375,
        707.730224609375,
        78.31001281738281
      ],
      "bbox_max": [
        867.0823364257812,
        722.9401245117188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        650.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        650.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        650.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        1190.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        650.0,
        344.507568359375,
        80.0
      ],
      "bbox_max": [
        660.0,
        515.8578491210938,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        650.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        784.1422119140625,
        640.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        804.1421508789062,
        660.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        98.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        784.1422119140625,
        640.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        660.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        1000.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1000.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -805.0,
      "bbox_min": [
        805.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        805.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        854.0377807617188,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1076.3074951171875,
        930.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        80.0
      ],
      "bbox_max": [
        1076.3074951171875,
        930.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        650.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1080.8577880859375,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        190.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        140.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        140.0
      ],
      "bbox_max": [
        868.9588623046875,
        516.0,
        190.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        660.0,
        341.656982421875,
        140.0
      ],
      "bbox_max": [
        868.9588623046875,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09435504674911499,
        -0.9955387115478516,
        0.0
      ],
      "plane_d": 260.87451171875,
      "bbox_min": [
        840.0,
        341.656982421875,
        155.0
      ],
      "bbox_max": [
        868.9588623046875,
        344.4016418457031,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09435504674911499,
        -0.9955387115478516,
        0.0
      ],
      "plane_d": 260.87451171875,
      "bbox_min": [
        840.0,
        341.656982421875,
        140.0
      ],
      "bbox_max": [
        868.9588623046875,
        344.4016418457031,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -661.0,
      "bbox_min": [
        660.0,
        476.0,
        140.0
      ],
      "bbox_max": [
        715.0,
        516.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 486.0,
      "bbox_min": [
        660.0,
        476.0,
        140.0
      ],
      "bbox_max": [
        661.0,
        486.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        660.0,
        476.0,
        150.0
      ],
      "bbox_max": [
        661.0,
        486.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 710.0,
      "bbox_min": [
        661.0,
        476.0,
        140.0
      ],
      "bbox_max": [
        715.0,
        516.0,
        155.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 498.6000061035156,
      "bbox_min": [
        710.0,
        494.6000061035156,
        144.0
      ],
      "bbox_max": [
        715.0,
        498.6000061035156,
        152.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -494.6000061035156,
      "bbox_min": [
        710.0,
        494.6000061035156,
        144.0
      ],
      "bbox_max": [
        715.0,
        498.6000061035156,
        152.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        710.0,
        494.6000061035156,
        144.0
      ],
      "bbox_max": [
        715.0,
        498.6000061035156,
        152.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 152.0,
      "bbox_min": [
        710.0,
        494.6000061035156,
        144.0
      ],
      "bbox_max": [
        715.0,
        498.6000061035156,
        152.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -144.0,
      "bbox_min": [
        710.0,
        494.6000061035156,
        144.0
      ],
      "bbox_max": [
        715.0,
        498.6000061035156,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9146992564201355,
        -0.40413516759872437,
        0.0
      ],
      "plane_d": -423.7064208984375,
      "bbox_min": [
        661.0,
        486.318359375,
        140.0
      ],
      "bbox_max": [
        703.5,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36198997497558594,
        -0.9321820139884949,
        -0.0
      ],
      "plane_d": 722.79248046875,
      "bbox_min": [
        661.0,
        491.0,
        140.0
      ],
      "bbox_max": [
        690.7314453125,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36198997497558594,
        -0.9321820139884949,
        0.0
      ],
      "plane_d": 229.9793243408203,
      "bbox_min": [
        670.199951171875,
        514.5,
        140.0
      ],
      "bbox_max": [
        690.7314453125,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146992564201355,
        -0.40413516759872437,
        -0.0
      ],
      "plane_d": 821.5651245117188,
      "bbox_min": [
        670.199951171875,
        514.5,
        140.0
      ],
      "bbox_max": [
        689.60009765625,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 515.5,
      "bbox_min": [
        671.7999267578125,
        514.5,
        140.0
      ],
      "bbox_max": [
        689.60009765625,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146992564201355,
        -0.40413516759872437,
        0.0
      ],
      "plane_d": 837.8469848632812,
      "bbox_min": [
        673.1790161132812,
        515.5,
        140.0
      ],
      "bbox_max": [
        688.2210083007812,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        688.0001831054688,
        515.5478515625,
        145.0
      ],
      "bbox_max": [
        688.199951171875,
        516.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9146992564201355,
        -0.40413516759872437,
        0.0
      ],
      "plane_d": -407.42462158203125,
      "bbox_min": [
        673.1790161132812,
        515.5,
        140.0
      ],
      "bbox_max": [
        688.199951171875,
        516.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        673.199951171875,
        515.5475463867188,
        145.0
      ],
      "bbox_max": [
        673.3998413085938,
        516.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        673.199951171875,
        515.5,
        145.0
      ],
      "bbox_max": [
        688.199951171875,
        516.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36198997497558594,
        -0.9321820139884949,
        0.0
      ],
      "plane_d": 729.2359619140625,
      "bbox_min": [
        671.7999267578125,
        514.5,
        140.0
      ],
      "bbox_max": [
        689.60009765625,
        515.5,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9146992564201355,
        -0.40413516759872437,
        0.0
      ],
      "plane_d": 837.8469848632812,
      "bbox_min": [
        688.2210083007812,
        514.9393310546875,
        140.0
      ],
      "bbox_max": [
        688.46875,
        515.5,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36198997497558594,
        -0.9321820139884949,
        0.0
      ],
      "plane_d": 236.42279052734375,
      "bbox_min": [
        671.7999267578125,
        514.5,
        140.0
      ],
      "bbox_max": [
        673.1790161132812,
        515.5,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9146992564201355,
        -0.40413516759872437,
        0.0
      ],
      "plane_d": -407.42462158203125,
      "bbox_min": [
        672.9312744140625,
        514.9393310546875,
        140.0
      ],
      "bbox_max": [
        673.1790161132812,
        515.5,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        661.0,
        491.0,
        140.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -142.0,
      "bbox_min": [
        661.0,
        491.0,
        140.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 491.0,
      "bbox_min": [
        661.0,
        491.0,
        140.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -506.0,
      "bbox_min": [
        661.0,
        506.0,
        140.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -145.0,
      "bbox_min": [
        661.0,
        491.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -503.5710754394531,
      "bbox_min": [
        661.0,
        491.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -142.39999389648438,
      "bbox_min": [
        661.0,
        491.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        491.800048828125,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 375.6911926269531,
      "bbox_min": [
        661.0,
        491.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        491.199951171875,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9977863430976868,
        -0.0,
        0.06650284677743912
      ],
      "plane_d": -670.3770141601562,
      "bbox_min": [
        661.0,
        492.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -505.0,
      "bbox_min": [
        661.0,
        492.0,
        142.0
      ],
      "bbox_max": [
        662.3999633789062,
        506.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 492.0,
      "bbox_min": [
        661.0,
        492.0,
        142.0
      ],
      "bbox_max": [
        662.39990234375,
        492.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -142.39999389648438,
      "bbox_min": [
        661.0,
        505.0,
        142.0
      ],
      "bbox_max": [
        662.3999633789062,
        506.0,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -516.0936279296875,
      "bbox_min": [
        661.0,
        505.0,
        142.0
      ],
      "bbox_max": [
        662.3999633789062,
        506.0,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 388.2137451171875,
      "bbox_min": [
        661.0,
        505.0,
        142.0
      ],
      "bbox_max": [
        662.39990234375,
        505.199951171875,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -142.39999389648438,
      "bbox_min": [
        662.3732299804688,
        505.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": -516.0936279296875,
      "bbox_min": [
        662.3732299804688,
        505.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        506.0,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944682478904724,
        0.4471317529678345
      ],
      "plane_d": 388.2137451171875,
      "bbox_min": [
        662.3732299804688,
        505.0,
        142.0
      ],
      "bbox_max": [
        665.0,
        505.199951171875,
        142.39999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -703.5,
      "bbox_min": [
        692.5,
        486.318359375,
        140.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44175076484680176,
        -0.44175076484680176,
        0.7808408737182617
      ],
      "plane_d": 408.04168701171875,
      "bbox_min": [
        692.5,
        486.318359375,
        140.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -144.5,
      "bbox_min": [
        692.5,
        486.318359375,
        140.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        148.29998779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 144.0,
      "bbox_min": [
        692.5,
        486.318359375,
        140.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        144.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": 438.94012451171875,
      "bbox_min": [
        692.5,
        486.318359375,
        144.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4187462329864502,
        0.15702983736991882,
        -0.8944234251976013
      ],
      "plane_d": 340.55401611328125,
      "bbox_min": [
        692.5,
        486.318359375,
        144.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4187462329864502,
        0.15702983736991882,
        -0.8944234251976013
      ],
      "plane_d": -239.749755859375,
      "bbox_min": [
        692.5,
        486.318359375,
        144.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.41873660683631897,
        -0.1570262312889099,
        -0.8944284915924072
      ],
      "plane_d": 496.31988525390625,
      "bbox_min": [
        692.5,
        486.318359375,
        144.0
      ],
      "bbox_max": [
        698.255615234375,
        491.1812744140625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1570262312889099,
        -0.41873660683631897,
        -0.8944284915924072
      ],
      "plane_d": 223.8678741455078,
      "bbox_min": [
        694.255615234375,
        486.318359375,
        144.0
      ],
      "bbox_max": [
        698.255615234375,
        488.403564453125,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4187318980693817,
        -0.15702447295188904,
        -0.8944311141967773
      ],
      "plane_d": -83.96774291992188,
      "bbox_min": [
        694.255615234375,
        492.3187255859375,
        144.0
      ],
      "bbox_max": [
        703.5,
        505.681640625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1570262312889099,
        0.41873660683631897,
        -0.8944284915924072
      ],
      "plane_d": -191.51885986328125,
      "bbox_min": [
        694.255615234375,
        503.596435546875,
        144.0
      ],
      "bbox_max": [
        698.255615234375,
        505.681640625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        0.0,
        -0.8944271802902222
      ],
      "plane_d": -182.23953247070312,
      "bbox_min": [
        695.5,
        492.3187255859375,
        144.0
      ],
      "bbox_max": [
        703.5,
        499.6812744140625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9971983432769775,
        0.0,
        0.07480204850435257
      ],
      "plane_d": 690.333740234375,
      "bbox_min": [
        703.0750122070312,
        495.1000061035156,
        144.0
      ],
      "bbox_max": [
        703.5,
        497.8999938964844,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9950366616249084,
        0.09950974583625793
      ],
      "plane_d": -509.7581481933594,
      "bbox_min": [
        703.0750122070312,
        495.1000061035156,
        144.0
      ],
      "bbox_max": [
        703.5,
        497.8999938964844,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9950366616249084,
        0.09950973093509674
      ],
      "plane_d": 478.3132629394531,
      "bbox_min": [
        703.0750122070312,
        495.1000061035156,
        144.0
      ],
      "bbox_max": [
        703.5,
        495.1500244140625,
        144.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35666364431381226,
        0.9289164543151855,
        -0.09952481836080551
      ],
      "plane_d": -191.900390625,
      "bbox_min": [
        694.59765625,
        487.7752685546875,
        140.0
      ],
      "bbox_max": [
        703.5,
        504.2247314453125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35652434825897217,
        -0.9289675951004028,
        -0.09954684227705002
      ],
      "plane_d": 219.69345092773438,
      "bbox_min": [
        694.59765625,
        487.7752685546875,
        140.0
      ],
      "bbox_max": [
        696.8231201171875,
        489.42578125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232978820800781,
        0.35427889227867126,
        -0.1483493596315384
      ],
      "plane_d": -795.075439453125,
      "bbox_min": [
        694.59765625,
        487.7752685546875,
        140.0
      ],
      "bbox_max": [
        696.8231201171875,
        489.42578125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232322573661804,
        -0.3544390797615051,
        -0.1483747363090515
      ],
      "plane_d": 835.8582763671875,
      "bbox_min": [
        694.59765625,
        487.7752685546875,
        140.0
      ],
      "bbox_max": [
        695.372802734375,
        488.7088623046875,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3565269708633423,
        -0.928974449634552,
        -0.09947340190410614
      ],
      "plane_d": 729.5115966796875,
      "bbox_min": [
        694.59765625,
        495.0,
        140.0
      ],
      "bbox_max": [
        703.5,
        504.2247314453125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.356611043214798,
        0.9289377331733704,
        -0.09951509535312653
      ],
      "plane_d": -701.8921508789062,
      "bbox_min": [
        694.59765625,
        502.57421875,
        140.0
      ],
      "bbox_max": [
        696.8231201171875,
        504.2247314453125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9232322573661804,
        -0.3544390797615051,
        -0.1483747363090515
      ],
      "plane_d": -443.50091552734375,
      "bbox_min": [
        694.59765625,
        502.57421875,
        140.0
      ],
      "bbox_max": [
        696.8231201171875,
        504.2247314453125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9232814311981201,
        0.35431891679763794,
        -0.14835569262504578
      ],
      "plane_d": 484.34674072265625,
      "bbox_min": [
        694.59765625,
        503.2911376953125,
        140.0
      ],
      "bbox_max": [
        695.372802734375,
        504.2247314453125,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -143.0,
      "bbox_min": [
        700.0,
        495.0,
        140.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9922779202461243,
        -0.12403474003076553
      ],
      "plane_d": 509.7828063964844,
      "bbox_min": [
        700.0,
        495.0,
        140.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701425433158875,
        0.0,
        -0.24253563582897186
      ],
      "plane_d": 714.510009765625,
      "bbox_min": [
        700.0,
        495.875,
        140.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -251.02288818359375,
      "bbox_min": [
        700.75,
        495.875,
        140.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -396.3333435058594,
      "bbox_min": [
        702.2777709960938,
        495.875,
        141.11111450195312
      ],
      "bbox_max": [
        703.5,
        498.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        0.0,
        -0.24253563582897186
      ],
      "plane_d": -647.0850830078125,
      "bbox_min": [
        702.2777709960938,
        496.0,
        141.11111450195312
      ],
      "bbox_max": [
        702.5,
        497.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9922779202461243,
        -0.12403474003076553
      ],
      "plane_d": -475.5491943359375,
      "bbox_min": [
        701.0,
        496.1111145019531,
        140.0
      ],
      "bbox_max": [
        702.5,
        497.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        0.0,
        -0.24253563582897186
      ],
      "plane_d": -647.0850830078125,
      "bbox_min": [
        702.0,
        496.1111145019531,
        140.0
      ],
      "bbox_max": [
        702.5,
        497.0,
        142.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 596.0910034179688,
      "bbox_min": [
        700.0,
        495.875,
        142.0
      ],
      "bbox_max": [
        701.0,
        498.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 451.1341247558594,
      "bbox_min": [
        700.0,
        495.0,
        142.0
      ],
      "bbox_max": [
        703.5,
        496.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": 596.0910034179688,
      "bbox_min": [
        700.0,
        495.0,
        142.0
      ],
      "bbox_max": [
        703.5,
        496.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -396.3333435058594,
      "bbox_min": [
        702.5,
        495.0,
        142.0
      ],
      "bbox_max": [
        703.5,
        496.0,
        143.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9971983432769775,
        0.0,
        0.07480204850435257
      ],
      "plane_d": 690.333740234375,
      "bbox_min": [
        703.0,
        495.0,
        143.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9950366616249084,
        0.09950973093509674
      ],
      "plane_d": 478.3132629394531,
      "bbox_min": [
        703.0,
        495.0,
        143.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9950366616249084,
        0.09950974583625793
      ],
      "plane_d": -509.7581481933594,
      "bbox_min": [
        703.0,
        497.8999938964844,
        143.0
      ],
      "bbox_max": [
        703.5,
        498.0,
        144.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -838.5070190429688,
      "bbox_min": [
        692.822509765625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        703.5,
        497.8499755859375,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 838.0069580078125,
      "bbox_min": [
        692.822509765625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        694.8375244140625,
        492.828857421875,
        148.29998779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.44175073504447937,
        -0.44175073504447937,
        -0.7808409333229065
      ],
      "plane_d": 637.60888671875,
      "bbox_min": [
        692.928466796875,
        490.9195556640625,
        145.70001220703125
      ],
      "bbox_max": [
        694.8375244140625,
        492.828857421875,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9939115643501282,
        0.11018045246601105,
        0.0
      ],
      "plane_d": 634.4796142578125,
      "bbox_min": [
        692.928466796875,
        490.9195556640625,
        145.70001220703125
      ],
      "bbox_max": [
        694.8375244140625,
        492.828857421875,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11059895157814026,
        -0.9938651323318481,
        0.0
      ],
      "plane_d": 411.1298828125,
      "bbox_min": [
        694.2012939453125,
        490.9195556640625,
        145.70001220703125
      ],
      "bbox_max": [
        694.8375244140625,
        490.9903564453125,
        148.29998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -837.5070190429688,
      "bbox_min": [
        692.822509765625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        693.9183349609375,
        491.909423828125,
        147.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 837.2071533203125,
      "bbox_min": [
        692.822509765625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        693.3880615234375,
        491.379150390625,
        147.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 142.5919189453125,
      "bbox_min": [
        692.822509765625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        693.3880615234375,
        491.379150390625,
        147.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -143.09185791015625,
      "bbox_min": [
        693.176025390625,
        490.8135986328125,
        144.49996948242188
      ],
      "bbox_max": [
        693.3880615234375,
        491.025634765625,
        147.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31642431020736694,
        -0.9486177563667297,
        0.0
      ],
      "plane_d": 246.39077758789062,
      "bbox_min": [
        693.0345458984375,
        491.025634765625,
        146.5
      ],
      "bbox_max": [
        693.9183349609375,
        491.909423828125,
        147.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486833214759827,
        0.3162277638912201,
        0.0
      ],
      "plane_d": 502.0826110839844,
      "bbox_min": [
        693.0345458984375,
        491.025634765625,
        146.5
      ],
      "bbox_max": [
        693.9183349609375,
        491.909423828125,
        147.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31621113419532776,
        -0.31621113419532776,
        -0.8944390416145325
      ],
      "plane_d": 505.7837219238281,
      "bbox_min": [
        693.0345458984375,
        491.025634765625,
        146.5
      ],
      "bbox_max": [
        693.9183349609375,
        491.909423828125,
        147.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31625476479530334,
        -0.31625476479530334,
        0.894408106803894
      ],
      "plane_d": 242.8748779296875,
      "bbox_min": [
        693.0345458984375,
        491.025634765625,
        147.25
      ],
      "bbox_max": [
        693.9183349609375,
        491.909423828125,
        147.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9971983432769775,
        0.0,
        0.07480204850435257
      ],
      "plane_d": 690.333740234375,
      "bbox_min": [
        703.112548828125,
        495.1500244140625,
        144.5
      ],
      "bbox_max": [
        703.5,
        497.8499755859375,
        147.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9950366616249084,
        0.09950973093509674
      ],
      "plane_d": 478.3132629394531,
      "bbox_min": [
        703.112548828125,
        495.1500244140625,
        144.5
      ],
      "bbox_max": [
        703.5,
        497.8499755859375,
        147.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9950366616249084,
        0.09950974583625793
      ],
      "plane_d": -509.7581481933594,
      "bbox_min": [
        703.112548828125,
        495.4000244140625,
        144.5
      ],
      "bbox_max": [
        703.5,
        497.8499755859375,
        147.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -147.0,
      "bbox_min": [
        703.300048828125,
        495.4000244140625,
        147.0
      ],
      "bbox_max": [
        703.5,
        497.5999755859375,
        147.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -143.49998474121094,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -491.0,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        651.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 471.0,
      "bbox_min": [
        650.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        651.0,
        471.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        651.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -491.0,
      "bbox_min": [
        651.0,
        491.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -472.0,
      "bbox_min": [
        651.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        472.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 471.0,
      "bbox_min": [
        651.0,
        471.0,
        140.0
      ],
      "bbox_max": [
        660.0,
        471.0,
        143.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        715.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        880.0,
        640.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 525.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        525.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        840.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        525.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        870.0,
        516.0,
        140.0
      ],
      "bbox_max": [
        870.0,
        525.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        650.0,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        324.5968933105469,
        120.0
      ],
      "bbox_max": [
        868.9588623046875,
        460.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.09435504674911499,
        -0.9955387115478516,
        0.0
      ],
      "plane_d": 260.87451171875,
      "bbox_min": [
        840.0,
        341.656982421875,
        120.0
      ],
      "bbox_max": [
        868.9588623046875,
        344.4016418457031,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        650.0,
        460.0,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        640.0,
        120.0
      ],
      "bbox_max": [
        880.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 139.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -491.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        491.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 471.0,
      "bbox_min": [
        650.0,
        471.0,
        139.0
      ],
      "bbox_max": [
        660.0,
        471.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        660.0,
        344.507568359375,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        660.0,
        344.507568359375,
        100.0
      ],
      "bbox_max": [
        840.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        660.0,
        344.507568359375,
        100.0
      ],
      "bbox_max": [
        660.0,
        460.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        840.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        840.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        930.0,
        387.9854736328125,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09435504674911499,
        -0.9955387115478516,
        0.0
      ],
      "plane_d": 260.87451171875,
      "bbox_min": [
        840.0,
        341.656982421875,
        190.0
      ],
      "bbox_max": [
        868.9588623046875,
        344.4016418457031,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        930.0,
        366.79339599609375,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1060.0,
        414.4813232421875,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1060.0,
        414.4813232421875,
        120.0
      ],
      "bbox_max": [
        1190.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1060.0,
        640.0,
        120.0
      ],
      "bbox_max": [
        1100.0,
        640.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        1060.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1150.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1060.0,
        640.0,
        220.0
      ],
      "bbox_max": [
        1100.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1060.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1060.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1170.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        930.0,
        366.79339599609375,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        250.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        930.0,
        366.79339599609375,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        930.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        930.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        950.0,
        640.0,
        120.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        930.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        950.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1040.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        950.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1040.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1118.2041015625,
      "bbox_min": [
        950.0,
        600.0,
        220.0
      ],
      "bbox_max": [
        1040.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        950.0,
        640.0,
        220.0
      ],
      "bbox_max": [
        990.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        930.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1036.0,
        650.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1000.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1074.1422119140625,
        916.4603881835938,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1150.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1240.0,
        941.2000122070312,
        160.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        941.2000122070312,
        160.0
      ],
      "bbox_max": [
        1240.0,
        1040.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1074.1422119140625,
        916.4603881835938,
        100.0
      ],
      "bbox_max": [
        1240.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        100.0
      ],
      "bbox_max": [
        1240.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1168.800048828125,
        930.0,
        100.0
      ],
      "bbox_max": [
        1240.0,
        945.107666015625,
        257.6921081542969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1168.800048828125,
        930.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        100.0
      ],
      "bbox_max": [
        1170.000244140625,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        130.0
      ],
      "bbox_max": [
        1170.0,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1094.1422119140625,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1240.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1240.0,
        940.108154296875,
        256.35247802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1101.1422119140625,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        957.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1235.0,
        887.8524780273438,
        290.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.4380493164062,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        866.4380493164062,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1215.0,
        760.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        866.4380493164062,
        720.11572265625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        720.1305541992188,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        865.3554077148438,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        1034.159912109375,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        865.3554077148438,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        866.4380493164062,
        721.2131958007812,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1100.0,
        785.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1132.5,
      "bbox_min": [
        1132.5,
        825.0,
        145.0
      ],
      "bbox_max": [
        1132.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1100.0,
        785.0,
        130.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1060.0,
        825.0,
        145.0
      ],
      "bbox_max": [
        1100.0,
        825.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1039.16015625,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8201950788497925,
        -0.3988734185695648,
        0.41009753942489624
      ],
      "plane_d": 1128.7607421875,
      "bbox_min": [
        1039.16015625,
        825.0,
        170.0
      ],
      "bbox_max": [
        1120.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -180.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1100.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1100.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1100.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1060.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        190.0
      ],
      "bbox_max": [
        1090.0,
        709.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1145.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        1113.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1145.0,
        820.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 690.6414184570312,
      "bbox_min": [
        1113.0,
        788.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -182.99998474121094,
      "bbox_min": [
        1114.0,
        789.0,
        180.0
      ],
      "bbox_max": [
        1136.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        1135.0,
        790.0,
        180.0
      ],
      "bbox_max": [
        1135.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1060.0,
        785.0,
        180.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        780.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 189.99998474121094,
      "bbox_min": [
        1160.0,
        709.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        739.0001220703125,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -183.49998474121094,
      "bbox_min": [
        1160.0,
        709.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        738.0,
        183.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        780.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 749.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        1060.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1130.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1189.0,
        749.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1130.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        750.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1060.0,
        749.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        770.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1060.0,
        749.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        770.0,
        183.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 189.99998474121094,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        749.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1189.0,
        738.0,
        190.0
      ],
      "bbox_max": [
        1189.0,
        749.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1189.0,
        749.0,
        183.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1189.0,
        738.0,
        180.0
      ],
      "bbox_max": [
        1189.0,
        749.0,
        183.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1060.0,
        770.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        780.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        1060.0,
        780.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        780.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1135.85791015625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        981.1421508789062,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1135.85791015625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        981.1421508789062,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        1225.0,
        1130.0,
        810.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        950.0,
        900.0,
        78.88888549804688
      ],
      "bbox_max": [
        1101.1422119140625,
        1130.0,
        580.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1084.542236328125,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1017.9999389648438,
        900.0,
        80.0
      ],
      "bbox_max": [
        1084.542236328125,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1084.542236328125,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1050.4000244140625,
        940.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1020.0,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1020.7999877929688,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1080.808837890625,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1050.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1017.9999389648438,
        900.0,
        80.0
      ],
      "bbox_max": [
        1074.1422119140625,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1010.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        930.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        1080.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1010.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1018.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        930.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        1083.7332763671875,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        950.0,
        900.0,
        78.88888549804688
      ],
      "bbox_max": [
        1010.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        78.88888549804688
      ],
      "bbox_max": [
        960.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        140.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        976.0,
        950.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 969.9999389648438,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        921.7156982421875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        950.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 969.9999389648438,
      "bbox_min": [
        960.0,
        970.0,
        108.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        104.99999237060547
      ],
      "bbox_max": [
        960.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1101.1422119140625,
        1109.5999755859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.3999633789062,
        950.0,
        140.0
      ],
      "bbox_max": [
        1101.1422119140625,
        1080.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        950.0,
        255.0000762939453
      ],
      "bbox_max": [
        1101.1422119140625,
        960.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        950.0,
        255.0000762939453
      ],
      "bbox_max": [
        1060.0,
        960.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1020.3999633789062,
        1070.0,
        140.0
      ],
      "bbox_max": [
        1040.0,
        1080.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        1010.7999877929688,
        950.0,
        140.0
      ],
      "bbox_max": [
        1038.0,
        1100.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1038.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.7999877929688,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1020.0,
        1083.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1094.14208984375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1055.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1055.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        995.8233032226562,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16859436035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        995.8233032226562,
        943.5999755859375,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16859436035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        986.7498168945312,
        937.2000122070312,
        220.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        940.6796264648438,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        958.2842407226562,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1101.1422119140625,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1101.1422119140625,
        957.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1130.0,
        600.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        760.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1130.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1130.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1130.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        780.0,
        1120.0,
        108.0
      ],
      "bbox_max": [
        845.0,
        1130.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        930.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        780.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        805.0,
        1045.0,
        110.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        780.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        760.0,
        900.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1130.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1040.0,
      "bbox_min": [
        760.0,
        1040.0,
        108.0
      ],
      "bbox_max": [
        780.0,
        1040.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112825989723206,
        -0.4117816090583801,
        -0.0
      ],
      "plane_d": 1143.894287109375,
      "bbox_min": [
        783.0528564453125,
        990.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        783.0528564453125,
        990.0,
        140.0
      ],
      "bbox_max": [
        946.9471435546875,
        1121.3931884765625,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        990.0,
        140.0
      ],
      "bbox_max": [
        865.0,
        1121.3931884765625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 1232.57763671875,
      "bbox_min": [
        805.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        865.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": 1163.89404296875,
      "bbox_min": [
        805.0,
        1006.109130859375,
        140.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9112828373908997,
        0.4117811918258667,
        0.0
      ],
      "plane_d": 303.2713623046875,
      "bbox_min": [
        805.0,
        1045.0,
        140.0
      ],
      "bbox_max": [
        822.5736083984375,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        950.0,
        950.0,
        453.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        892.7614135742188,
        900.0,
        249.50100708007812
      ],
      "bbox_max": [
        950.0,
        924.7737426757812,
        453.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        570.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        824.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        760.0,
        615.8578491210938,
        98.0
      ],
      "bbox_max": [
        824.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3826822340488434,
        0.9238800406455994,
        0.0
      ],
      "plane_d": -309.68353271484375,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        784.1422119140625,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        770.0000610351562,
        654.1421508789062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        760.0,
        615.8578491210938,
        60.0
      ],
      "bbox_max": [
        794.1422119140625,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        780.0,
        640.0,
        60.0
      ],
      "bbox_max": [
        794.1422119140625,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 676.1616821289062,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        830.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        830.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -91.92388916015625,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1031.99462890625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        780.0,
        750.0,
        60.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        118.00000762939453
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07647191733121872,
        -0.07647191733121872,
        0.9941348433494568
      ],
      "plane_d": 57.35394287109375,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        910.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1017.8524780273438,
        900.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        1017.8524780273438,
        900.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7073715925216675,
        0.7068419456481934,
        0.0
      ],
      "plane_d": 83.90362548828125,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        852.3160400390625,
        728.2843017578125,
        118.0
      ],
      "bbox_max": [
        858.2843017578125,
        734.2525634765625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1081.87353515625,
      "bbox_min": [
        760.0,
        715.8578491210938,
        118.0
      ],
      "bbox_max": [
        900.2081909179688,
        856.0660400390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1053.589111328125,
      "bbox_min": [
        760.0,
        715.8578491210938,
        118.0
      ],
      "bbox_max": [
        774.1421508789062,
        730.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1231.87353515625,
      "bbox_min": [
        886.0660400390625,
        841.9238891601562,
        118.0
      ],
      "bbox_max": [
        900.2081909179688,
        856.0660400390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -61.2132568359375,
      "bbox_min": [
        774.1421508789062,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1141.87353515625,
      "bbox_min": [
        774.1421508789062,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1053.589111328125,
      "bbox_min": [
        774.1421508789062,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        788.2843017578125,
        715.8578491210938,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        893.431396484375,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        836.568603515625,
        734.2525634765625,
        118.0
      ],
      "bbox_max": [
        980.0,
        893.431396484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        836.568603515625,
        734.2525634765625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        764.1421508789062,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1141.87353515625,
      "bbox_min": [
        850.7107543945312,
        748.4000244140625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        764.1421508789062,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.806619126109581e-07,
        -0.4517251253128052,
        -0.8921571969985962
      ],
      "plane_d": 379.4711608886719,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        721.5499877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        760.0,
        682.0499267578125,
        63.31644058227539
      ],
      "bbox_max": [
        770.0,
        715.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        760.0,
        682.0499267578125,
        80.0
      ],
      "bbox_max": [
        770.0,
        686.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        715.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        760.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        770.0,
        682.0499267578125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        760.0,
        715.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        715.0,
        63.31644058227539
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        858.2843017578125,
        721.2131958007812,
        118.0
      ],
      "bbox_max": [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        858.2843017578125,
        721.2131958007812,
        118.0
      ],
      "bbox_max": [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1121.87353515625,
      "bbox_min": [
        858.2843017578125,
        721.2131958007812,
        118.0
      ],
      "bbox_max": [
        865.3554077148438,
        728.2843017578125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9778023958206177,
        0.0,
        0.2095290869474411
      ],
      "plane_d": 697.033447265625,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1074.14208984375,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1074.14208984375,
        1080.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": -65.76275634765625,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1074.14208984375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7077255845069885,
        0.7064874172210693,
        0.0
      ],
      "plane_d": 48.61865234375,
      "bbox_min": [
        1037.0,
        970.0,
        750.0
      ],
      "bbox_max": [
        1061.0999755859375,
        994.1422119140625,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        1130.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        620.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1130.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        620.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1130.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        720.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        980.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        1130.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        980.0,
        78.0
      ],
      "bbox_max": [
        721.0,
        1111.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        721.0,
        980.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        1120.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        620.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        620.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        620.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        620.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1090.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        620.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        620.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        740.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        721.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        980.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        620.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        740.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        240.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        696.142333984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        620.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        696.142333984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        696.142333984375,
        80.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.9243307113647461,
        -0.381592333316803,
        0.0
      ],
      "plane_d": -444.47320556640625,
      "bbox_min": [
        754.1616821289062,
        662.01953125,
        78.0
      ],
      "bbox_max": [
        760.0,
        676.1616821289062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -75.154296875,
      "bbox_min": [
        638.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        710.9116821289062,
        611.698486328125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -930.2266845703125,
      "bbox_min": [
        703.8406372070312,
        604.62744140625,
        78.0
      ],
      "bbox_max": [
        710.9116821289062,
        611.698486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9483067989349365,
        0.31735536456108093,
        0.0
      ],
      "plane_d": -778.2506713867188,
      "bbox_min": [
        638.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        639.9603271484375,
        545.8578491210938,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        684.1421508789062,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        620.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        630.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        630.0,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        660.0,
        516.2720947265625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        630.0,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        630.0,
        487.2720031738281,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        659.0,
        514.8578491210938,
        78.0
      ],
      "bbox_max": [
        660.0,
        516.2720947265625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 554.5448608398438,
      "bbox_min": [
        650.0,
        505.8578186035156,
        60.0
      ],
      "bbox_max": [
        659.0,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        623.85791015625,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9796782732009888,
        -0.20057573914527893,
        0.0
      ],
      "plane_d": 719.490966796875,
      "bbox_min": [
        623.85791015625,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        650.0,
        505.8578186035156,
        78.0
      ],
      "bbox_max": [
        650.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 630.0,
      "bbox_min": [
        630.0,
        485.8578186035156,
        78.0
      ],
      "bbox_max": [
        630.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        620.0,
        556.14208984375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        556.14208984375,
        78.0
      ],
      "bbox_max": [
        623.85791015625,
        560.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        620.0,
        590.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        676.1422729492188,
        78.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        78.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        620.0,
        590.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        620.0,
        590.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        620.0,
        704.1421508789062,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 704.1422119140625,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        657.1543579101562,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        657.1543579101562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        2.1591460608760826e-05
      ],
      "plane_d": -930.2283935546875,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        649.8406372070312,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 910.2266845703125,
      "bbox_min": [
        651.5563354492188,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        675.5563354492188,
        635.698486328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        656.1539306640625,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 704.1422119140625,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        740.0,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        80.0
      ],
      "bbox_max": [
        760.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        620.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -239.99998474121094,
      "bbox_min": [
        620.0,
        750.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        650.0,
        850.0,
        160.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        620.0,
        475.8577880859375,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        98.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        98.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        620.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        624.1422119140625,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        620.0,
        485.0,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        620.0,
        485.0,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        660.0,
        515.8578491210938,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        660.0,
        515.8578491210938,
        190.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.0,
      "bbox_min": [
        620.0,
        495.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        658.9852905273438,
        555.0899658203125,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        658.9852905273438,
        555.0899658203125,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        663.6920776367188,
        564.4789428710938,
        100.0
      ],
      "bbox_max": [
        673.1273803710938,
        573.9141845703125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        658.9852905273438,
        559.7703247070312,
        98.0
      ],
      "bbox_max": [
        673.1273803710938,
        573.9141845703125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        658.9852905273438,
        559.7703247070312,
        98.0
      ],
      "bbox_max": [
        670.76318359375,
        571.5499267578125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072827219963074,
        -0.7069308161735535,
        0.0
      ],
      "plane_d": 866.8078002929688,
      "bbox_min": [
        658.9852905273438,
        559.7703247070312,
        98.0
      ],
      "bbox_max": [
        666.0545654296875,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7072827219963074,
        -0.7069308161735535,
        0.0
      ],
      "plane_d": 866.8078002929688,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        670.7326049804688,
        559.7703857421875,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1563720703125,
        99.9787368774414
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        673.1273803710938,
        562.1563720703125,
        100.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        1130.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -190.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1110.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        1090.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1110.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1000.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        440.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        360.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        360.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        869.8349609375,
        460.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        818.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        560.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        360.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        620.0,
        560.0,
        78.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        540.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        360.0,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        620.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.85065096616745,
        -0.2763929069042206,
        0.4472135007381439
      ],
      "plane_d": -265.04254150390625,
      "bbox_min": [
        399.4853820800781,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        580.5146484375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506511449813843,
        0.27639296650886536,
        0.44721314311027527
      ],
      "plane_d": -486.1569519042969,
      "bbox_min": [
        399.4853820800781,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        580.5146484375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506504893302917,
        0.27639275789260864,
        0.4472145736217499
      ],
      "plane_d": 347.4808349609375,
      "bbox_min": [
        416.7721252441406,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        580.5146484375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506681442261,
        -0.2763928174972534,
        0.44721418619155884
      ],
      "plane_d": 568.5951538085938,
      "bbox_min": [
        416.7721252441406,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        580.5146484375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312059402466,
        0.7236067056655884,
        0.4472137689590454
      ],
      "plane_d": 9.384857177734375,
      "bbox_min": [
        416.7721252441406,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        563.2279052734375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 433.5480041503906,
      "bbox_min": [
        500.0,
        280.5788269042969,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        319.3297424316406,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        -1.0,
        0.0
      ],
      "plane_d": 318.819580078125,
      "bbox_min": [
        523.7213745117188,
        318.8202209472656,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        300.0,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        -1.0,
        0.0
      ],
      "plane_d": 318.819580078125,
      "bbox_min": [
        523.0200805664062,
        318.8202209472656,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257312655448914,
        0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": -505.831787109375,
      "bbox_min": [
        416.7721252441406,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        563.2279052734375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -442.9906921386719,
      "bbox_min": [
        455.27862548828125,
        274.18280029296875,
        78.0
      ],
      "bbox_max": [
        480.0,
        319.3297424316406,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        -1.0,
        0.0
      ],
      "plane_d": 318.8207702636719,
      "bbox_min": [
        455.27862548828125,
        318.8202209472656,
        78.0
      ],
      "bbox_max": [
        456.27862548828125,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        455.27862548828125,
        300.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        -1.0,
        0.0
      ],
      "plane_d": 318.8207702636719,
      "bbox_min": [
        455.27862548828125,
        318.8202209472656,
        78.0
      ],
      "bbox_max": [
        456.9800109863281,
        318.8202209472656,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312655448914,
        -0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": 588.2703857421875,
      "bbox_min": [
        416.7721252441406,
        300.85906982421875,
        78.0
      ],
      "bbox_max": [
        563.2279052734375,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 433.5479736328125,
      "bbox_min": [
        500.0,
        480.6702575683594,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        523.7213745117188,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        523.0200805664062,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257313251495361,
        -0.7236069440841675,
        0.4472130835056305
      ],
      "plane_d": 73.05374145507812,
      "bbox_min": [
        416.7721252441406,
        300.85906982421875,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -442.9906921386719,
      "bbox_min": [
        455.27862548828125,
        480.6702575683594,
        78.0
      ],
      "bbox_max": [
        480.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        456.27862548828125,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        480.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        456.9799499511719,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.2344612514425535e-06,
        1.0,
        -0.0
      ],
      "plane_d": -481.180419921875,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        524.7213745117188,
        499.1409912109375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        480.0,
        481.1798095703125,
        78.0
      ],
      "bbox_max": [
        500.0,
        499.1409912109375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        481.1798095703125,
        78.0
      ],
      "bbox_max": [
        480.0,
        499.1408996582031,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        480.0,
        300.85906982421875,
        78.0
      ],
      "bbox_max": [
        500.0,
        318.8201904296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        300.8591003417969,
        78.0
      ],
      "bbox_max": [
        480.0,
        318.8201904296875,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        360.0,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        620.0,
        520.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8506506681442261,
        -0.2763928174972534,
        0.44721418619155884
      ],
      "plane_d": 568.5951538085938,
      "bbox_min": [
        400.5368347167969,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        579.4631958007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.85065096616745,
        -0.2763929069042206,
        0.4472135007381439
      ],
      "plane_d": -265.04254150390625,
      "bbox_min": [
        400.5368347167969,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8506511449813843,
        0.27639296650886536,
        0.44721314311027527
      ],
      "plane_d": -486.1569519042969,
      "bbox_min": [
        400.5368347167969,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -442.9906921386719,
      "bbox_min": [
        417.6227722167969,
        265.9959411621094,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5257313251495361,
        -0.7236069440841675,
        0.4472130835056305
      ],
      "plane_d": 73.05374145507812,
      "bbox_min": [
        417.6227722167969,
        319.3297424316406,
        60.0
      ],
      "bbox_max": [
        465.27862548828125,
        480.6702575683594,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5257312655448914,
        0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": -505.831787109375,
      "bbox_min": [
        417.6227722167969,
        319.3297424316406,
        60.0
      ],
      "bbox_max": [
        465.27862548828125,
        352.9771728515625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312655448914,
        -0.7236068844795227,
        0.447213351726532
      ],
      "plane_d": 588.2703857421875,
      "bbox_min": [
        456.27862548828125,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": 433.5479736328125,
      "bbox_min": [
        514.7213745117188,
        476.08453369140625,
        60.0
      ],
      "bbox_max": [
        523.7213745117188,
        520.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257312059402466,
        0.7236067056655884,
        0.4472137689590454
      ],
      "plane_d": 9.384857177734375,
      "bbox_min": [
        456.27862548828125,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        562.3772583007812,
        352.9771728515625,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 433.5480041503906,
      "bbox_min": [
        481.8045654296875,
        270.6849365234375,
        60.0
      ],
      "bbox_max": [
        523.7213745117188,
        323.91546630859375,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -299.9999694824219,
      "bbox_min": [
        481.8045654296875,
        300.0,
        60.0
      ],
      "bbox_max": [
        523.7213745117188,
        300.0,
        78.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        456.27862548828125,
        300.0,
        60.0
      ],
      "bbox_max": [
        497.1163024902344,
        300.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        360.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        818.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622788310050964,
        0.31622788310050964,
        0.8944271206855774
      ],
      "plane_d": -121.60807800292969,
      "bbox_min": [
        521.5,
        579.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        818.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9998459219932556,
        0.017557965591549873,
        0.0
      ],
      "plane_d": -546.2263793945312,
      "bbox_min": [
        521.5,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        818.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -521.5,
      "bbox_min": [
        521.5,
        792.0,
        65.0
      ],
      "bbox_max": [
        532.4025268554688,
        818.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        521.5,
        792.0,
        65.0
      ],
      "bbox_max": [
        532.4025268554688,
        818.0,
        68.19999694824219
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 799.2000122070312,
      "bbox_min": [
        529.5,
        799.2000122070312,
        65.0
      ],
      "bbox_max": [
        530.0,
        799.2000122070312,
        68.19999694824219
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        532.1206665039062,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        808.0476684570312,
        80.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        532.9449462890625,
        724.0,
        65.0
      ],
      "bbox_max": [
        575.7156982421875,
        762.6718139648438,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7945672273635864,
        -0.6071763634681702,
        -0.0
      ],
      "plane_d": 898.0770263671875,
      "bbox_min": [
        547.4688110351562,
        760.8700561523438,
        65.0
      ],
      "bbox_max": [
        548.8456420898438,
        762.6718139648438,
        79.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        532.9449462890625,
        724.0,
        65.0
      ],
      "bbox_max": [
        565.7156982421875,
        761.1082153320312,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7938141822814941,
        0.6081603765487671,
        -0.0
      ],
      "plane_d": -884.3927001953125,
      "bbox_min": [
        535.2213745117188,
        743.2847290039062,
        65.0
      ],
      "bbox_max": [
        556.4309692382812,
        755.6007080078125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        544.5025024414062,
        743.2847290039062,
        79.0
      ],
      "bbox_max": [
        556.4309692382812,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        550.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 550.0,
      "bbox_min": [
        550.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -570.0,
      "bbox_min": [
        570.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        360.0,
        266.0564880371094,
        80.0
      ],
      "bbox_max": [
        620.0,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        620.0,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0002752529107965529,
        -0.0
      ],
      "plane_d": -550.2064208984375,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        584.9010009765625,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4225330054759979,
        -0.49339815974235535,
        0.7602789998054504
      ],
      "plane_d": -152.93255615234375,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5712229013442993,
        -0.8207949995994568,
        0.0
      ],
      "plane_d": 901.202392578125,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48428842425346375,
        -0.4842880964279175,
        0.7286493182182312
      ],
      "plane_d": -177.67437744140625,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        512.6419067382812,
        792.0,
        80.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -521.5,
      "bbox_min": [
        521.5,
        792.0,
        80.0
      ],
      "bbox_max": [
        521.5,
        818.0,
        84.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        360.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        360.0
      ],
      "bbox_max": [
        499.9961853027344,
        784.537353515625,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        549.9669799804688,
        799.9862060546875,
        240.0
      ],
      "bbox_max": [
        584.9010009765625,
        869.8349609375,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -239.99998474121094,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        620.0,
        834.9010009765625,
        260.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        553.146240234375,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        753.2847290039062,
        81.70327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        556.4309692382812,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        753.2847290039062,
        81.70327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -259.9999694824219,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        550.0,
        799.9862060546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00027554581174626946,
        -0.0
      ],
      "plane_d": -550.2066650390625,
      "bbox_min": [
        549.9862060546875,
        750.0,
        240.0
      ],
      "bbox_max": [
        550.0,
        799.9862060546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        360.0,
        266.0564880371094,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        360.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        360.0,
        490.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        360.0,
        490.0,
        220.0
      ],
      "bbox_max": [
        380.0,
        510.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 430.0,
      "bbox_min": [
        360.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        743.2847290039062,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        360.0,
        580.0,
        160.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        360.0,
        580.0,
        160.0
      ],
      "bbox_max": [
        430.0,
        650.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        550.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -905.0967407226562,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 933.3810424804688,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 926.1088256835938,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        750.0,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        575.7156982421875,
        734.0,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        739.1421508789062,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        550.0,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        739.7156982421875,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        724.0,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        240.0
      ],
      "bbox_max": [
        550.0,
        750.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        360.0
      ],
      "bbox_max": [
        499.9961853027344,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -360.0,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        360.0
      ],
      "bbox_max": [
        499.9961853027344,
        750.0,
        360.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 220.0,
      "bbox_min": [
        360.0,
        266.0564880371094,
        80.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        449.9999694824219,
        580.0,
        220.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        450.0,
        580.0,
        220.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        379.9999694824219,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        220.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        399.4853820800781,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9510565996170044,
        -0.3090168535709381,
        0.0
      ],
      "plane_d": -256.3264465332031,
      "bbox_min": [
        399.4853820800781,
        318.8202209472656,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": -503.5399475097656,
      "bbox_min": [
        399.4853820800781,
        318.8202209472656,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877854824066162,
        -0.8090169429779053,
        0.0
      ],
      "plane_d": 121.67640686035156,
      "bbox_min": [
        399.4853820800781,
        318.8202209472656,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5877854824066162,
        0.8090169429779053,
        0.0
      ],
      "plane_d": -525.537109375,
      "bbox_min": [
        399.4853820800781,
        318.8202209472656,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        399.4853820800781,
        318.8202209472656,
        107.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9510564208030701,
        0.3090173304080963,
        -0.0
      ],
      "plane_d": -523.5400390625,
      "bbox_min": [
        420.5146179199219,
        343.5415954589844,
        118.0
      ],
      "bbox_max": [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510564208030701,
        -0.3090173304080963,
        0.0
      ],
      "plane_d": -276.3262023925781,
      "bbox_min": [
        420.5146179199219,
        343.5415954589844,
        118.0
      ],
      "bbox_max": [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877860188484192,
        0.8090164661407471,
        -0.0
      ],
      "plane_d": -545.5372314453125,
      "bbox_min": [
        433.78515625,
        343.5415954589844,
        118.0
      ],
      "bbox_max": [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877856016159058,
        -0.809016764163971,
        0.0
      ],
      "plane_d": 101.67626953125,
      "bbox_min": [
        433.78515625,
        440.84246826171875,
        118.0
      ],
      "bbox_max": [
        455.27862548828125,
        456.4584045410156,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.951056718826294,
        -0.30901652574539185,
        0.0
      ],
      "plane_d": -256.333740234375,
      "bbox_min": [
        406.0986328125,
        372.5364990234375,
        107.0
      ],
      "bbox_max": [
        408.416259765625,
        427.4635009765625,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.951056718826294,
        0.30901652574539185,
        -0.0
      ],
      "plane_d": -503.5469665527344,
      "bbox_min": [
        406.0986328125,
        372.5364990234375,
        107.0
      ],
      "bbox_max": [
        408.416259765625,
        379.66943359375,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        220.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        455.27862548828125,
        500.0,
        80.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        215.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 508.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        510.0,
        145.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -133.5,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        580.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        508.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        508.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        215.0
      ],
      "bbox_max": [
        524.7213745117188,
        510.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        -0.3090168535709381,
        -0.0
      ],
      "plane_d": 675.7090454101562,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -130.0,
      "bbox_min": [
        549.6473388671875,
        450.0,
        127.12169647216797
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 28.7691650390625,
      "bbox_min": [
        549.6473388671875,
        485.0,
        127.12169647216797
      ],
      "bbox_max": [
        559.7213745117188,
        495.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        549.6473388671875,
        485.0,
        127.1217041015625
      ],
      "bbox_max": [
        559.7213745117188,
        495.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        552.896484375,
        485.0,
        128.05003356933594
      ],
      "bbox_max": [
        559.7213745117188,
        485.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        549.6473388671875,
        450.0,
        130.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5390536785125732,
        -0.8422713875770569
      ],
      "plane_d": -121.62398529052734,
      "bbox_min": [
        590.0,
        450.0,
        145.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        590.0,
        450.0,
        145.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 150.0,
      "bbox_min": [
        590.0,
        450.0,
        145.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        590.0,
        450.0,
        145.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 615.0,
      "bbox_min": [
        615.0,
        450.0,
        145.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -605.0,
      "bbox_min": [
        590.0,
        452.1875,
        145.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.371390700340271,
        -0.9284767508506775
      ],
      "plane_d": 310.1112365722656,
      "bbox_min": [
        590.0,
        452.1875,
        145.0
      ],
      "bbox_max": [
        605.0,
        472.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        590.0,
        452.1875,
        145.0
      ],
      "bbox_max": [
        605.0,
        472.5,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        600.0,
        460.0,
        145.0
      ],
      "bbox_max": [
        605.0,
        460.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        590.0,
        452.1875,
        145.0
      ],
      "bbox_max": [
        590.0,
        472.5,
        150.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 615.0,
      "bbox_min": [
        605.0,
        452.1875,
        145.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        615.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        615.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        615.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        485.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5390536785125732,
        0.8422713875770569
      ],
      "plane_d": 130.04669189453125,
      "bbox_min": [
        605.0,
        467.8125,
        145.0
      ],
      "bbox_max": [
        615.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        605.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        615.0,
        495.0,
        162.40000915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        605.0,
        495.0,
        156.0
      ],
      "bbox_max": [
        615.0,
        495.0,
        162.40000915527344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        605.0,
        485.0,
        162.40000915527344
      ],
      "bbox_max": [
        615.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        605.0,
        495.0,
        162.40000915527344
      ],
      "bbox_max": [
        615.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        549.6473388671875,
        450.0,
        130.0
      ],
      "bbox_max": [
        615.0,
        500.0,
        145.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.371390700340271,
        0.9284767508506775
      ],
      "plane_d": -300.82647705078125,
      "bbox_min": [
        590.0,
        450.0,
        130.0
      ],
      "bbox_max": [
        615.0,
        485.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        590.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        144.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        590.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        144.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        590.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        144.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 615.0,
      "bbox_min": [
        615.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        460.0,
        144.00001525878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -450.0,
      "bbox_min": [
        590.0,
        450.0,
        130.0
      ],
      "bbox_max": [
        615.0,
        485.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        590.0,
        450.0,
        130.0
      ],
      "bbox_max": [
        615.0,
        485.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5390536785125732,
        0.8422713875770569
      ],
      "plane_d": 130.04669189453125,
      "bbox_min": [
        600.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        467.8125,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 615.0,
      "bbox_min": [
        600.0,
        450.0,
        140.0
      ],
      "bbox_max": [
        615.0,
        467.8125,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 460.0,
      "bbox_min": [
        600.0,
        460.0,
        140.0
      ],
      "bbox_max": [
        605.0,
        460.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        590.0,
        450.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        485.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.371390700340271,
        -0.9284767508506775
      ],
      "plane_d": 310.1112365722656,
      "bbox_min": [
        590.0,
        472.5,
        140.0
      ],
      "bbox_max": [
        600.0,
        485.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        549.6473388671875,
        485.0,
        130.0
      ],
      "bbox_max": [
        600.0,
        500.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        549.6473388671875,
        485.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        500.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -19.15392303466797,
      "bbox_min": [
        549.6473388671875,
        485.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        495.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        549.6473388671875,
        495.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        495.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510565996170044,
        0.3090168535709381,
        0.0
      ],
      "plane_d": 428.49554443359375,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        -0.8090171217918396,
        -0.0
      ],
      "plane_d": 697.7061767578125,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        498.8175964355469,
        481.1797790527344,
        80.0
      ],
      "bbox_max": [
        552.896484375,
        500.0,
        215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        524.7213745117188,
        485.0,
        120.0
      ],
      "bbox_max": [
        552.896484375,
        495.0,
        138.05003356933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -19.15392303466797,
      "bbox_min": [
        524.7213745117188,
        485.0,
        120.0
      ],
      "bbox_max": [
        552.896484375,
        495.0,
        138.05003356933594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2747211158275604,
        0.0,
        0.9615239500999451
      ],
      "plane_d": 28.7691650390625,
      "bbox_min": [
        524.7213745117188,
        485.0,
        120.0
      ],
      "bbox_max": [
        552.896484375,
        495.0,
        137.1217041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        524.7213745117188,
        495.0,
        120.0
      ],
      "bbox_max": [
        549.6473388671875,
        495.0,
        137.1217041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        498.8175964355469,
        481.1797790527344,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        498.8175964355469,
        481.1797790527344,
        120.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        512.5814208984375,
        490.0,
        185.0
      ],
      "bbox_max": [
        524.7213745117188,
        490.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        498.8175964355469,
        490.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        512.5814208984375,
        490.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        490.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        498.8175964355469,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        498.8175964355469,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        498.8175964355469,
        495.0,
        100.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": 396.11688232421875,
      "bbox_min": [
        514.7213745117188,
        495.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877851843833923,
        0.8090171217918396,
        0.0
      ],
      "plane_d": 50.492431640625,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": 524.7213745117188,
      "bbox_min": [
        465.9248962402344,
        276.1020812988281,
        80.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": -299.9999694824219,
      "bbox_min": [
        465.9248962402344,
        276.1020812988281,
        80.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        220.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        465.9248962402344,
        276.1020812988281,
        80.0
      ],
      "bbox_max": [
        524.7213745117188,
        300.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        480.0,
        280.0,
        80.0
      ],
      "bbox_max": [
        505.0,
        300.0,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        495.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        495.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        280.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -289.0,
      "bbox_min": [
        480.0,
        280.0,
        80.0
      ],
      "bbox_max": [
        495.0,
        297.2264099121094,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 280.0,
      "bbox_min": [
        480.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        495.0,
        286.3282775878906,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        280.0,
        118.0
      ],
      "bbox_max": [
        480.0,
        286.3282775878906,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        485.0,
        289.0,
        80.0
      ],
      "bbox_max": [
        495.0,
        297.2264099121094,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        485.0,
        289.0,
        130.0
      ],
      "bbox_max": [
        495.0,
        297.2264099121094,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        498.8175354003906,
        300.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        498.8175354003906,
        300.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        305.0,
        215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        505.0,
        300.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        305.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        505.0,
        300.0,
        185.0
      ],
      "bbox_max": [
        524.7213745117188,
        305.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        505.0,
        300.0,
        215.0
      ],
      "bbox_max": [
        524.7213745117188,
        305.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": 396.11688232421875,
      "bbox_min": [
        505.0,
        300.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        305.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        505.0,
        300.0,
        95.5
      ],
      "bbox_max": [
        514.7213745117188,
        305.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        498.8175354003906,
        300.0,
        95.5
      ],
      "bbox_max": [
        505.0,
        304.4918212890625,
        215.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        498.8175354003906,
        300.0,
        185.0
      ],
      "bbox_max": [
        505.0,
        304.4918212890625,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        498.81756591796875,
        300.0,
        215.0
      ],
      "bbox_max": [
        505.0,
        304.4918212890625,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        498.81756591796875,
        300.0,
        95.5
      ],
      "bbox_max": [
        505.0,
        304.4917907714844,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        498.81756591796875,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        304.4917907714844,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        498.81756591796875,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        304.4917907714844,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        505.699462890625,
        305.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        505.699462890625,
        305.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        310.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        512.5813598632812,
        310.0,
        185.0
      ],
      "bbox_max": [
        524.7213745117188,
        310.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        505.699462890625,
        305.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        310.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        512.5813598632812,
        310.0,
        155.0
      ],
      "bbox_max": [
        524.7213745117188,
        310.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -300.0,
      "bbox_min": [
        455.2785949707031,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.27862548828125,
        275.0924072265625,
        80.0
      ],
      "bbox_max": [
        498.81756591796875,
        300.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09441311657428741,
        -0.9955331683158875,
        -6.076252248021774e-06
      ],
      "plane_d": 230.88070678710938,
      "bbox_min": [
        455.27862548828125,
        275.0924072265625,
        215.0
      ],
      "bbox_max": [
        465.9249267578125,
        276.10211181640625,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        480.0,
        286.3282775878906,
        80.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        286.3282775878906,
        118.0
      ],
      "bbox_max": [
        480.0,
        300.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 299.0,
      "bbox_min": [
        485.0,
        289.9609375,
        80.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        485.0,
        299.0,
        80.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        485.0,
        299.0,
        80.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        485.0,
        299.0,
        90.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        485.0,
        299.0,
        120.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        495.0,
        299.0,
        120.0
      ],
      "bbox_max": [
        495.0,
        300.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        485.0,
        289.9609375,
        80.0
      ],
      "bbox_max": [
        495.0,
        299.0,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        485.0,
        289.9609375,
        130.0
      ],
      "bbox_max": [
        495.0,
        299.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -318.8202209472656,
      "bbox_min": [
        455.2785949707031,
        300.0,
        85.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        524.7213745117188,
        318.8202209472656,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -310.0,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        512.5813598632812,
        318.8201904296875,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        512.5813598632812,
        310.0,
        185.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        455.2785949707031,
        300.0,
        185.0
      ],
      "bbox_max": [
        512.5813598632812,
        310.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -305.0,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        505.6994934082031,
        310.0,
        155.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        505.6994934082031,
        305.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        480.0,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        305.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 505.0,
      "bbox_min": [
        480.0,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        305.0,
        155.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        305.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        300.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        305.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": -216.08425903320312,
      "bbox_min": [
        455.2785949707031,
        300.0,
        87.5
      ],
      "bbox_max": [
        465.2785949707031,
        305.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        305.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        310.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        305.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        310.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        305.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        310.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.0,
      "bbox_min": [
        505.0,
        305.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        310.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        480.0,
        310.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        318.8201904296875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        480.0,
        310.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        318.8201904296875,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        310.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        318.8201904296875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -505.0,
      "bbox_min": [
        505.0,
        310.0,
        118.0
      ],
      "bbox_max": [
        505.0,
        318.8201904296875,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 481.1797790527344,
      "bbox_min": [
        455.2785949707031,
        318.8201904296875,
        85.0
      ],
      "bbox_max": [
        580.5146484375,
        500.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        455.2785949707031,
        481.1797790527344,
        85.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        455.2785949707031,
        481.1797790527344,
        120.0
      ],
      "bbox_max": [
        524.7213745117188,
        500.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 490.0,
      "bbox_min": [
        455.2785949707031,
        490.0,
        155.0
      ],
      "bbox_max": [
        512.5814208984375,
        500.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 185.0,
      "bbox_min": [
        455.2785949707031,
        490.0,
        155.0
      ],
      "bbox_max": [
        512.5814208984375,
        500.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        455.2785949707031,
        490.0,
        155.0
      ],
      "bbox_max": [
        512.5814208984375,
        500.0,
        155.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 495.0,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        505.6996154785156,
        500.0,
        114.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        455.2785949707031,
        495.0,
        87.5
      ],
      "bbox_max": [
        505.6996154785156,
        500.0,
        114.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        455.2785949707031,
        495.0,
        87.5
      ],
      "bbox_max": [
        505.6996154785156,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": -216.08425903320312,
      "bbox_min": [
        455.2785949707031,
        495.0,
        87.5
      ],
      "bbox_max": [
        465.2785949707031,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 499.9794921875,
      "bbox_min": [
        485.0,
        499.9794921875,
        107.0
      ],
      "bbox_max": [
        492.5,
        499.9794921875,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -486.5,
      "bbox_min": [
        455.2785949707031,
        486.5,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        455.2785949707031,
        318.8201904296875,
        107.0
      ],
      "bbox_max": [
        580.5146484375,
        481.1797790527344,
        120.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        455.27862548828125,
        318.8201904296875,
        118.0
      ],
      "bbox_max": [
        580.5146484375,
        481.1797790527344,
        120.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.951056718826294,
        -0.30901670455932617,
        0.0
      ],
      "plane_d": 655.7090454101562,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        559.4854125976562,
        461.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056718826294,
        0.30901670455932617,
        0.0
      ],
      "plane_d": 408.4956970214844,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        559.4854125976562,
        461.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877847671508789,
        -0.8090173602104187,
        0.0
      ],
      "plane_d": 677.7059936523438,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        546.2149047851562,
        461.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877847671508789,
        0.8090173602104187,
        0.0
      ],
      "plane_d": 30.49212646484375,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        546.2149047851562,
        461.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877856016159058,
        -0.809016764163971,
        0.0
      ],
      "plane_d": 101.67626953125,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        461.77703857421875,
        461.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877860188484192,
        0.8090164661407471,
        -0.0
      ],
      "plane_d": -545.5372314453125,
      "bbox_min": [
        455.27862548828125,
        338.8202209472656,
        118.0
      ],
      "bbox_max": [
        461.7770080566406,
        343.5415954589844,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056718826294,
        -0.30901652574539185,
        -0.0
      ],
      "plane_d": 675.6542358398438,
      "bbox_min": [
        570.7611694335938,
        370.15887451171875,
        107.0
      ],
      "bbox_max": [
        573.0787963867188,
        429.84112548828125,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.951056718826294,
        0.30901652574539185,
        0.0
      ],
      "plane_d": 428.4410400390625,
      "bbox_min": [
        570.7611694335938,
        370.15887451171875,
        107.0
      ],
      "bbox_max": [
        573.0787963867188,
        377.29180908203125,
        114.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        449.9999694824219,
        580.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 580.0,
      "bbox_min": [
        449.9999694824219,
        580.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        580.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        549.9669799804688,
        799.8020629882812,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        600.1320190429688,
        920.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        580.0322265625,
        920.0,
        60.0
      ],
      "bbox_max": [
        610.132080078125,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071070075035095,
        -0.7071065902709961,
        -0.0
      ],
      "plane_d": 820.2514038085938,
      "bbox_min": [
        360.0,
        749.9893188476562,
        60.0
      ],
      "bbox_max": [
        590.0321655273438,
        930.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        879.8848876953125,
        60.0
      ],
      "bbox_max": [
        590.0321655273438,
        930.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        499.802001953125,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        489.8018798828125,
        920.0,
        60.0
      ],
      "bbox_max": [
        590.0321655273438,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -400.0,
        250.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        310.0,
        346.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        310.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -330.0,
      "bbox_min": [
        310.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        330.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 540.0,
      "bbox_min": [
        330.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        359.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        921.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        359.0,
        579.0,
        78.0
      ],
      "bbox_max": [
        360.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        979.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 482.99066162109375,
      "bbox_min": [
        350.0,
        570.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        579.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        960.0,
        105.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -462.0,
      "bbox_min": [
        -310.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 305.0,
      "bbox_min": [
        -310.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -457.94677734375,
      "bbox_min": [
        -310.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -305.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 285.0,
      "bbox_min": [
        -290.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        104.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        0.44721364974975586
      ],
      "plane_d": -457.94677734375,
      "bbox_min": [
        -290.0,
        460.0,
        100.0
      ],
      "bbox_max": [
        -285.0,
        462.0,
        104.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 520.0,
      "bbox_min": [
        -200.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        650.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -55.0,
        470.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        300.0,
        480.0,
        78.0
      ],
      "bbox_max": [
        310.0,
        500.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        290.0,
        280.0,
        140.0
      ],
      "bbox_max": [
        290.0,
        440.0,
        381.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: elev",
      "entity_class": "CSlidingDoor",
      "piece_name": "elev",
      "offset": 17817,
      "centroid": [
        490.0,
        294.0,
        80.5
      ],
      "bbox_min": [
        485.0,
        289.0,
        80.0
      ],
      "bbox_max": [
        495.0,
        299.0,
        81.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 10.0,
        "height_z": 1.0,
        "door_width": 10.0,
        "door_depth": 10.0,
        "leaf_depth": 9.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          495.0,
          299.0,
          80.0
        ],
        [
          485.0,
          299.0,
          80.0
        ],
        [
          495.0,
          289.0,
          80.0
        ],
        [
          485.0,
          289.0,
          80.0
        ],
        [
          485.0,
          299.0,
          81.0
        ],
        [
          495.0,
          299.0,
          81.0
        ],
        [
          495.0,
          289.0,
          81.0
        ],
        [
          485.0,
          289.0,
          81.0
        ]
      ],
      "plane_distance": -299.0,
      "authentic_texture": "airmetrobottom1"
    },
    {
      "tag": "CSlidingDoor piece: panel1",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel1",
      "offset": 21417,
      "centroid": [
        571.8200073242188,
        373.725341796875,
        110.5
      ],
      "bbox_min": [
        570.6611938476562,
        370.15887451171875,
        107.0
      ],
      "bbox_max": [
        572.9788208007812,
        377.29180908203125,
        114.0
      ],
      "dimensions_source": {
        "span_x": 2.317626953125,
        "span_y": 7.1329345703125,
        "height_z": 7.0,
        "door_width": 7.1329345703125,
        "door_depth": 2.317626953125,
        "leaf_depth": 2.277626953125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -0.9511,
          0.309,
          0.0
        ]
      },
      "vertices": [
        [
          570.6611938476562,
          370.15887451171875,
          107.0
        ],
        [
          572.9788208007812,
          377.29180908203125,
          107.0
        ],
        [
          572.9788208007812,
          377.29180908203125,
          114.0
        ],
        [
          570.6611938476562,
          370.15887451171875,
          114.0
        ]
      ],
      "plane_distance": 428.3459
    },
    {
      "tag": "CSlidingDoor piece: panel2",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel2",
      "offset": 22125,
      "centroid": [
        571.8200073242188,
        426.274658203125,
        110.5
      ],
      "bbox_min": [
        570.6611938476562,
        422.70819091796875,
        107.0
      ],
      "bbox_max": [
        572.9788208007812,
        429.84112548828125,
        114.0
      ],
      "dimensions_source": {
        "span_x": 2.317626953125,
        "span_y": 7.1329345703125,
        "height_z": 7.0,
        "door_width": 7.1329345703125,
        "door_depth": 2.317626953125,
        "leaf_depth": 2.277626953125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -0.9511,
          -0.309,
          -0.0
        ]
      },
      "vertices": [
        [
          570.6611938476562,
          429.84112548828125,
          107.0
        ],
        [
          572.9788208007812,
          422.70819091796875,
          107.0
        ],
        [
          572.9788208007812,
          422.70819091796875,
          114.0
        ],
        [
          570.6611938476562,
          429.84112548828125,
          114.0
        ]
      ],
      "plane_distance": 675.5591
    },
    {
      "tag": "CSlidingDoor piece: panel4",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel4",
      "offset": 22837,
      "centroid": [
        407.3574523925781,
        423.89703369140625,
        110.5
      ],
      "bbox_min": [
        406.1986389160156,
        420.33056640625,
        107.0
      ],
      "bbox_max": [
        408.5162658691406,
        427.4635009765625,
        114.0
      ],
      "dimensions_source": {
        "span_x": 2.317626953125,
        "span_y": 7.1329345703125,
        "height_z": 7.0,
        "door_width": 7.1329345703125,
        "door_depth": 2.317626953125,
        "leaf_depth": 2.277626953125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.9511,
          -0.309,
          0.0
        ]
      },
      "vertices": [
        [
          406.1986389160156,
          420.33056640625,
          107.0
        ],
        [
          408.5162658691406,
          427.4635009765625,
          107.0
        ],
        [
          408.5162658691406,
          427.4635009765625,
          114.0
        ],
        [
          406.1986389160156,
          420.33056640625,
          114.0
        ]
      ],
      "plane_distance": -256.4288
    },
    {
      "tag": "CSlidingDoor piece: panel5",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel5",
      "offset": 23549,
      "centroid": [
        407.3574523925781,
        376.10296630859375,
        110.5
      ],
      "bbox_min": [
        406.1986389160156,
        372.5364990234375,
        107.0
      ],
      "bbox_max": [
        408.5162658691406,
        379.66943359375,
        114.0
      ],
      "dimensions_source": {
        "span_x": 2.317626953125,
        "span_y": 7.1329345703125,
        "height_z": 7.0,
        "door_width": 7.1329345703125,
        "door_depth": 2.317626953125,
        "leaf_depth": 2.277626953125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.9511,
          0.309,
          0.0
        ]
      },
      "vertices": [
        [
          406.1986389160156,
          379.66943359375,
          107.0
        ],
        [
          408.5162658691406,
          372.5364990234375,
          107.0
        ],
        [
          408.5162658691406,
          372.5364990234375,
          114.0
        ],
        [
          406.1986389160156,
          379.66943359375,
          114.0
        ]
      ],
      "plane_distance": -503.6421
    },
    {
      "tag": "CSlidingDoor piece: panel3",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel3",
      "offset": 24261,
      "centroid": [
        488.75,
        499.8794860839844,
        110.5
      ],
      "bbox_min": [
        485.0,
        499.8794860839844,
        107.0
      ],
      "bbox_max": [
        492.5,
        499.8794860839844,
        114.0
      ],
      "dimensions_source": {
        "span_x": 7.5,
        "span_y": 0.0,
        "height_z": 7.0,
        "door_width": 7.5,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          485.0,
          499.8794860839844,
          107.0
        ],
        [
          492.5,
          499.8794860839844,
          107.0
        ],
        [
          492.5,
          499.8794860839844,
          114.0
        ],
        [
          485.0,
          499.8794860839844,
          114.0
        ]
      ],
      "plane_distance": 499.8795
    },
    {
      "tag": "CSlidingDoor piece: panel6",
      "entity_class": "CSlidingDoor",
      "piece_name": "panel6",
      "offset": 24973,
      "centroid": [
        488.75,
        305.10052490234375,
        110.5
      ],
      "bbox_min": [
        485.0,
        305.10052490234375,
        107.0
      ],
      "bbox_max": [
        492.5,
        305.10052490234375,
        114.0
      ],
      "dimensions_source": {
        "span_x": 7.5,
        "span_y": 0.0,
        "height_z": 7.0,
        "door_width": 7.5,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          485.0,
          305.10052490234375,
          107.0
        ],
        [
          492.5,
          305.10052490234375,
          114.0
        ],
        [
          492.5,
          305.10052490234375,
          107.0
        ],
        [
          485.0,
          305.10052490234375,
          114.0
        ]
      ],
      "plane_distance": -305.1005,
      "authentic_texture": "elevdr1"
    }
  ],
  "tutorial_messages": []
}